<!-- eslint-disable -->
<template>
  <div>
    <div id="travel-form" class="tw-w-full tw-px-4 md:tw-px-0 md:tw-w-10/12 tw-mt-12 tw-mb-6 tw-flex tw-flex-wrap tw-justify-between tw-pb-5">

    <!-- Progress Stepper -->
    <div class="tw-w-full tw-mb-8">
      <v-card flat class="tw-mb-4">
        <v-card-text class="tw-p-4">
          <v-stepper
            v-model="currentStep"
            :items="stepItems"
            hide-actions
            flat
            class="elevation-0"
          >
            <template #item="{ item }">
              <div
                class="stepper-item tw-cursor-pointer"
                :class="{ 'tw-text-blue-600': item && currentStep === item.value }"
              >
                {{ item && item.title }}
              </div>
            </template>
          </v-stepper>
        </v-card-text>
      </v-card>
    </div>

    <!-- Step 1: Plan Selection and Basic Info -->
    <div v-if="currentStep === 1" class="tw-w-full">
      <div class="tw-p-8 tw-bg-white tw-rounded-lg tw-shadow-lg tw-mb-8">
          <!-- Plan Type Selection -->
          <div class="tw-mb-8">
            <h3 class="c-blue-text tw-text-lg tw-font-bold tw-mb-6 tw-text-center">Choose Your Plan Type</h3>
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
              <v-card
                :class="['plan-option tw-cursor-pointer', selectedPlan === 'individual' ? 'tw-border-2 tw-border-blue-600' : '']"
                :color="selectedPlan === 'individual' ? 'primary' : 'surface'"
                @click="selectedPlan = 'individual'"
                hover
                elevation="4"
                class="tw-p-6 tw-text-center"
              >
                <v-icon size="48" :color="selectedPlan === 'individual' ? 'white' : 'primary'" class="tw-mb-4">mdi-account</v-icon>
                <h4 class="tw-text-lg tw-font-bold tw-mb-2" :class="selectedPlan === 'individual' ? 'tw-text-white' : ''">Individual Plan</h4>
                <p class="tw-text-sm tw-mb-0" :class="selectedPlan === 'individual' ? 'tw-text-white' : 'tw-text-gray-600'">Perfect for solo travelers</p>
              </v-card>
              <v-card
                :class="['plan-option tw-cursor-pointer', selectedPlan === 'family' ? 'tw-border-2 tw-border-blue-600' : '']"
                :color="selectedPlan === 'family' ? 'primary' : 'surface'"
                @click="selectedPlan = 'family'"
                hover
                elevation="4"
                class="tw-p-6 tw-text-center"
              >
                <v-icon size="48" :color="selectedPlan === 'family' ? 'white' : 'primary'" class="tw-mb-4">mdi-account-group</v-icon>
                <h4 class="tw-text-lg tw-font-bold tw-mb-2" :class="selectedPlan === 'family' ? 'tw-text-white' : ''">Family Plan</h4>
                <p class="tw-text-sm tw-mb-0" :class="selectedPlan === 'family' ? 'tw-text-white' : 'tw-text-gray-600'">Great for families traveling together</p>
              </v-card>
              <v-card
                :class="['plan-option tw-cursor-pointer', selectedPlan === 'student' ? 'tw-border-2 tw-border-blue-600' : '']"
                :color="selectedPlan === 'student' ? 'primary' : 'surface'"
                @click="selectedPlan = 'student'"
                hover
                elevation="4"
                class="tw-p-6 tw-text-center"
              >
                <v-icon size="48" :color="selectedPlan === 'student' ? 'white' : 'primary'" class="tw-mb-4">mdi-school</v-icon>
                <h4 class="tw-text-lg tw-font-bold tw-mb-2" :class="selectedPlan === 'student' ? 'tw-text-white' : ''">Student Plan</h4>
                <p class="tw-text-sm tw-mb-0" :class="selectedPlan === 'student' ? 'tw-text-white' : 'tw-text-gray-600'">Designed for students abroad</p>
              </v-card>
            </div>
          </div>



            <!-- Saved quotes are now available for authenticated users in the SavedQuotes page -->
          </div>


          <!-- Next Step Button -->
          <v-card class="tw-mt-8">
            <v-card-text class="tw-p-6 tw-text-center">
              <v-btn
                @click="nextStep"
                color="primary"
                size="large"
                :disabled="!selectedPlan"
                class="tw-px-8"
              >
                <v-icon start>mdi-arrow-right</v-icon>
                Continue with {{ selectedPlan === 'individual' ? 'Individual' : selectedPlan === 'family' ? 'Family' : 'Student' }} Plan
              </v-btn>
            </v-card-text>
          </v-card>
      </div>
    </div>

    <!-- Step 2: Quote Details -->
    <div v-if="currentStep === 2" class="tw-w-full">
      <v-card class="tw-mb-8" elevation="4">
        <v-card-text class="tw-p-8">
          <v-form v-model="isValid">

        <!-- Quote Configuration Section -->
        <v-card elevation="2" class="tw-w-full tw-mb-8 tw-overflow-hidden">
          <!-- Modern Header with Gradient -->
          <div class="tw-bg-gradient-to-r tw-from-blue-800 tw-to-blue-900 tw-text-white tw-px-6 tw-py-6">
            <div class="tw-flex tw-items-center tw-space-x-3">
              <div class="tw-bg-white tw-bg-opacity-20 tw-rounded-full tw-p-3">
                <v-icon size="24" color="white">mdi-cog</v-icon>
              </div>
              <div>
                <h3 class="tw-text-xl tw-font-bold tw-mb-1">Configure Your Quote</h3>
                <p class="tw-text-blue-100 tw-text-sm">Tell us about your travel plans to get personalized coverage</p>
              </div>
            </div>
          </div>

          <v-card-text class="tw-px-6 tw-py-8">
            <!-- Step Indicator -->
            <div class="tw-mb-8">
              <div class="tw-flex tw-items-center tw-justify-center tw-space-x-4 tw-mb-4">
                <div class="tw-flex tw-items-center tw-space-x-2">
                  <div class="tw-w-8 tw-h-8 tw-bg-blue-600 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold">1</div>
                  <span class="tw-text-sm tw-font-medium tw-text-blue-600">Personal Details</span>
                </div>
                <div class="tw-w-12 tw-h-0.5 tw-bg-gray-300"></div>
                <div class="tw-flex tw-items-center tw-space-x-2">
                  <div class="tw-w-8 tw-h-8 tw-bg-blue-600 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold">2</div>
                  <span class="tw-text-sm tw-font-medium tw-text-blue-600">Travel Plans</span>
                </div>
                <div class="tw-w-12 tw-h-0.5 tw-bg-gray-300"></div>
                <div class="tw-flex tw-items-center tw-space-x-2">
                  <div class="tw-w-8 tw-h-8 tw-bg-gray-300 tw-text-gray-600 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-semibold">3</div>
                  <span class="tw-text-sm tw-font-medium tw-text-gray-600">Coverage Review</span>
                </div>
              </div>
            </div>

            <!-- Form Fields with Enhanced Styling -->
            <div class="tw-space-y-6">
              <!-- Who is travelling Section - Only for Individual Plan -->
              <div v-if="selectedPlan === 'individual'" class="tw-bg-gradient-to-br tw-from-purple-50 tw-to-indigo-50 tw-rounded-xl tw-p-6">
                <h4 class="c-blue-text tw-font-semibold tw-text-lg tw-mb-4 tw-flex tw-items-center">
                  <v-icon class="tw-mr-2" color="primary">mdi-account-question</v-icon>
                  Who is travelling? *
                </h4>
                <p class="tw-text-gray-600 tw-text-sm tw-mb-6">Let's find a cover that fits you</p>
                
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                  <v-card 
                    :class="['tw-cursor-pointer tw-transition-all tw-duration-200', buyingFor === 'myself' ? 'tw-border-2 tw-border-blue-600 tw-bg-blue-50' : 'tw-border tw-border-gray-200']"
                    @click="buyingFor = 'myself'"
                    elevation="2"
                    hover
                  >
                    <v-card-text class="tw-p-6 tw-text-center">
                      <div class="tw-flex tw-flex-col tw-items-center tw-space-y-3">
                        <div :class="['tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center', buyingFor === 'myself' ? 'tw-bg-blue-600' : 'tw-bg-gray-200']">
                          <v-icon :color="buyingFor === 'myself' ? 'white' : 'gray'" size="24">mdi-account</v-icon>
                        </div>
                        <div>
                          <h5 :class="['tw-font-semibold tw-mb-1', buyingFor === 'myself' ? 'tw-text-blue-700' : 'tw-text-gray-700']">Myself</h5>
                          <p class="tw-text-xs tw-text-gray-600">I am the principal applicant (18+ years)</p>
                        </div>
                      </div>
                      <v-radio-group v-model="buyingFor" class="tw-hidden">
                        <v-radio value="myself"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card 
                    :class="['tw-cursor-pointer tw-transition-all tw-duration-200', buyingFor === 'someone_else' ? 'tw-border-2 tw-border-blue-600 tw-bg-blue-50' : 'tw-border tw-border-gray-200']"
                    @click="buyingFor = 'someone_else'"
                    elevation="2"
                    hover
                  >
                    <v-card-text class="tw-p-6 tw-text-center">
                      <div class="tw-flex tw-flex-col tw-items-center tw-space-y-3">
                        <div :class="['tw-w-12 tw-h-12 tw-rounded-full tw-flex tw-items-center tw-justify-center', buyingFor === 'someone_else' ? 'tw-bg-blue-600' : 'tw-bg-gray-200']">
                          <v-icon :color="buyingFor === 'someone_else' ? 'white' : 'gray'" size="24">mdi-account-heart</v-icon>
                        </div>
                        <div>
                          <h5 :class="['tw-font-semibold tw-mb-1', buyingFor === 'someone_else' ? 'tw-text-blue-700' : 'tw-text-gray-700']">Someone else</h5>
                          <p class="tw-text-xs tw-text-gray-600">I'm buying for family member/friend</p>
                        </div>
                      </div>
                      <v-radio-group v-model="buyingFor" class="tw-hidden">
                        <v-radio value="someone_else"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

              <!-- Personal Information Section -->
              <div class="tw-bg-gray-50 tw-rounded-xl tw-p-6">
                <h4 class="c-blue-text tw-font-semibold tw-text-lg tw-mb-4 tw-flex tw-items-center">
                  <v-icon class="tw-mr-2" color="primary">mdi-account</v-icon>
                  <span v-if="selectedPlan === 'individual'">
                    {{ buyingFor === 'myself' ? 'Your Personal Information' : 'Traveller\'s Personal Information' }}
                  </span>
                  <span v-else-if="selectedPlan === 'family'">
                    Primary Applicant Information
                  </span> 
                  <span v-else>
                    Your Personal Information
                  </span>
                </h4>
                <p v-if="selectedPlan === 'individual' && buyingFor === 'myself'" class="tw-text-gray-600 tw-text-sm tw-mb-4">
                  As the principal applicant (18+ years), please provide your details
                </p>
                <p v-else-if="selectedPlan === 'individual' && buyingFor === 'someone_else'" class="tw-text-gray-600 tw-text-sm tw-mb-4">
                  Please provide the traveller's details (you're buying coverage for them)
                </p>
                <p v-else-if="selectedPlan === 'family'" class="tw-text-gray-600 tw-text-sm tw-mb-4">
                  Please provide the primary applicant's details (18+ years) - this person will be the policy holder
                </p>
                <p v-else class="tw-text-gray-600 tw-text-sm tw-mb-4">
                  As the applicant (18+ years), please provide your details
                </p>
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                  <!-- Email Address -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-sm tw-font-medium tw-text-gray-700">Email Address</label>
                    <v-text-field
                      v-model="emailAddress"
                      type="email"
                      placeholder="your.email@example.com"
                      variant="outlined"
                      density="comfortable"
                      :error-messages="emailError"
                      prepend-inner-icon="mdi-email"
                      @blur="validateEmail"
                      @keyup="validateEmailOnKeyup"
                      :rules="[required('Email Address'), emailFormat()]"
                      class="tw-bg-white"
                      color="primary"
                    />
                  </div>

                  <!-- Date of Birth -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-sm tw-font-medium tw-text-gray-700">Date of Birth</label>
                    <v-menu
                      v-model="birthDateMenu"
                      :close-on-content-click="false"
                      transition="fade-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="birthDateFormatted"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          variant="outlined"
                          density="comfortable"
                          :placeholder="getDateOfBirthPlaceholder()"
                          :rules="[required('Date of Birth'), ageValidation]"
                          class="tw-bg-white"
                          color="primary"
                          :error="!isApplicantOldEnough"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="birthDate"
                        :max="maxDateString"
                        :min="minDateString"
                        no-title
                        @input="birthDateMenu = false"
                        color="primary"
                        elevation="8"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </div>
              </div>

              <!-- Travel Details Section -->
              <div class="tw-bg-gradient-to-br tw-from-green-50 tw-to-blue-50 tw-rounded-xl tw-p-6">
                <h4 class="c-blue-text tw-font-semibold tw-text-lg tw-mb-4 tw-flex tw-items-center">
                  <v-icon class="tw-mr-2" color="primary">mdi-airplane</v-icon>
                  Travel Details
                </h4>
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6">
                  <!-- Destination Region -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-sm tw-font-medium tw-text-gray-700">Destination Region</label>
                    <v-select
                      v-model="selectedRegion"
                      :items="regions"
                      item-text="label"
                      item-value="value"
                      placeholder="Select region"
                      variant="outlined"
                      density="comfortable"
                      :rules="[required('Destination Region')]"
                      clearable
                      prepend-inner-icon="mdi-earth"
                      class="tw-bg-white"
                      color="primary"
                    ></v-select>
                  </div>

                  <!-- Specific Destination Country -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-sm tw-font-medium tw-text-gray-700">Destination Country</label>
                    <v-select
                      v-model="selectedCountry"
                      :items="filteredDestinationCountries"
                      item-text="TRC_NAME"
                      item-value="TRC_SHT_DESC"
                      placeholder="Select country"
                      variant="outlined"
                      density="comfortable"
                      :rules="[required('Destination Country')]"
                      clearable
                      searchable
                      prepend-inner-icon="mdi-map-marker"
                      class="tw-bg-white"
                      color="primary"
                    ></v-select>
                  </div>

                  <!-- Trip Duration -->
                  <div class="tw-space-y-2">
                    <label class="tw-text-sm tw-font-medium tw-text-gray-700">Trip Duration</label>
                    <v-select
                      v-model="selectedDuration"
                      :items="durations"
                      item-text="label"
                      item-value="value"
                      placeholder="Select duration"
                      variant="outlined"
                      density="comfortable"
                      :rules="[required('Trip Duration')]"
                      clearable
                      prepend-inner-icon="mdi-clock-outline"
                      class="tw-bg-white"
                      color="primary"
                    ></v-select>
                  </div>
                </div>
              </div>

              <!-- Enhanced Regional Benefits Display -->
              <div v-if="selectedRegion" class="tw-transition-all tw-duration-300 tw-ease-in-out">
                <v-card elevation="4" class="tw-border-l-4 tw-border-l-blue-500">
                  <v-card-text class="tw-p-6">
                    <div class="tw-flex tw-items-center tw-justify-between tw-mb-6">
                      <div>
                        <h5 class="c-blue-text tw-text-lg tw-font-bold tw-mb-1">Coverage Benefits</h5>
                        <p class="tw-text-gray-600 tw-text-sm">Protection for {{ getRegionDisplayName(selectedRegion) }}</p>
                      </div>
                      <div class="tw-bg-blue-100 tw-rounded-full tw-p-3">
                        <v-icon color="primary" size="24">mdi-shield-check</v-icon>
                      </div>
                    </div>
                    
                    <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-4">
                      <div class="tw-text-center tw-p-4 tw-bg-green-50 tw-rounded-lg tw-border tw-border-green-100">
                        <div class="tw-bg-green-100 tw-rounded-full tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center">
                          <v-icon color="success" size="20">mdi-medical-bag</v-icon>
                        </div>
                        <div class="tw-text-xl tw-font-bold tw-text-green-600 tw-mb-1">${{ getRegionBenefits(selectedRegion).medical.toLocaleString() }}</div>
                        <div class="tw-text-xs tw-text-gray-600 tw-font-medium">Medical Expenses</div>
                      </div>
                      
                      <div class="tw-text-center tw-p-4 tw-bg-orange-50 tw-rounded-lg tw-border tw-border-orange-100">
                        <div class="tw-bg-orange-100 tw-rounded-full tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center">
                          <v-icon color="warning" size="20">mdi-helicopter</v-icon>
                        </div>
                        <div class="tw-text-xl tw-font-bold tw-text-orange-600 tw-mb-1">${{ getRegionBenefits(selectedRegion).evacuation.toLocaleString() }}</div>
                        <div class="tw-text-xs tw-text-gray-600 tw-font-medium">Emergency Evacuation</div>
                      </div>
                      
                      <div class="tw-text-center tw-p-4 tw-bg-blue-50 tw-rounded-lg tw-border tw-border-blue-100">
                        <div class="tw-bg-blue-100 tw-rounded-full tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center">
                          <v-icon color="info" size="20">mdi-calendar-remove</v-icon>
                        </div>
                        <div class="tw-text-xl tw-font-bold tw-text-blue-600 tw-mb-1">${{ getRegionBenefits(selectedRegion).cancellation.toLocaleString() }}</div>
                        <div class="tw-text-xs tw-text-gray-600 tw-font-medium">Trip Cancellation</div>
                      </div>
                      
                      <div class="tw-text-center tw-p-4 tw-bg-purple-50 tw-rounded-lg tw-border tw-border-purple-100">
                        <div class="tw-bg-purple-100 tw-rounded-full tw-w-12 tw-h-12 tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center">
                          <v-icon color="deep-purple" size="20">mdi-bag-personal</v-icon>
                        </div>
                        <div class="tw-text-xl tw-font-bold tw-text-purple-600 tw-mb-1">${{ getRegionBenefits(selectedRegion).effects.toLocaleString() }}</div>
                        <div class="tw-text-xs tw-text-gray-600 tw-font-medium">Personal Effects</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Get Price Button -->
              <div v-if="canGetPrice && !price" class="tw-transition-all tw-duration-300 tw-ease-in-out tw-mt-6">
                <v-card variant="outlined" class="tw-border-primary">
                  <v-card-text class="tw-p-6 tw-text-center">
                    <v-btn
                      @click="fetchPricing"
                      color="primary"
                      size="large"
                      :loading="loadingPrice"
                      :disabled="!canGetPrice"
                      class="tw-px-8"
                    >
                      <v-icon start>mdi-calculator</v-icon>
                      Get Price
                    </v-btn>
                    <div class="tw-mt-3 tw-text-sm tw-text-gray-600">
                      Click to calculate your travel insurance premium
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Enhanced Price Display -->
              <div v-if="price && birthDate" class="tw-transition-all tw-duration-300 tw-ease-in-out">
                <v-card class="tw-bg-gradient-to-r tw-from-green-500 tw-to-emerald-600 tw-text-white" elevation="6">
                  <v-card-text class="tw-p-6">
                    <div class="tw-flex tw-items-center tw-justify-between">
                      <div>
                        <div class="tw-flex tw-items-center tw-mb-2">
                          <v-icon color="white" class="tw-mr-2">mdi-check-circle</v-icon>
                          <span class="tw-text-sm tw-text-green-100 tw-font-medium">Your Premium</span>
                        </div>
                        <div class="tw-text-3xl tw-font-bold tw-mb-1">KSh {{ formatPriceKSH(price) }}</div>
                        <div class="tw-text-sm tw-text-green-100">
                          {{ selectedPlan === 'individual' ? 'Individual' : selectedPlan === 'family' ? 'Family' : 'Student' }} plan
                          • {{ selectedRegionDisplay }} • {{ selectedDurationDisplay }}
                        </div>
                      </div>
                      <div class="tw-bg-white tw-bg-opacity-20 tw-rounded-full tw-p-4">
                        <v-icon color="white" size="32">mdi-currency-usd</v-icon>
                      </div>
                    </div>
                    <div class="tw-mt-4 tw-pt-4 tw-border-t tw-border-white tw-border-opacity-20">
                      <v-btn
                        @click="fetchPricing"
                        color="white"
                        variant="outlined"
                        size="small"
                        :loading="loadingPrice"
                        class="tw-text-green-600"
                      >
                        <v-icon start size="small">mdi-refresh</v-icon>
                        Recalculate
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Enhanced Loading State -->
              <div v-if="loadingPrice" class="tw-transition-all tw-duration-300 tw-ease-in-out">
                <v-card variant="outlined" class="tw-border-dashed">
                  <v-card-text class="tw-p-6 tw-text-center">
                    <v-progress-circular indeterminate color="primary" size="40" class="tw-mb-4" />
                    <h5 class="tw-text-lg tw-font-semibold tw-text-gray-700 tw-mb-2">Calculating Your Premium</h5>
                    <p class="tw-text-sm tw-text-gray-500">We're analyzing your travel plans to provide the best coverage options...</p>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Next Step Button -->
        <v-card class="tw-mt-8">
          <v-card-text class="tw-p-6 tw-text-center">
            <v-btn
              @click="nextStep"
              color="primary"
              size="large"
              :disabled="!emailAddress || !birthDate || !selectedRegion || !selectedDuration || !!emailError || loadingPrice"
              class="tw-px-8"
            >
              <v-icon start>mdi-arrow-right</v-icon>
              Continue
            </v-btn>
          </v-card-text>
        </v-card>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

    <!-- Step 3: Residency Selection -->
    <div v-if="currentStep === 3" class="tw-w-full">
      <v-card class="tw-mb-8" elevation="4">
        <v-card-text class="tw-p-8">
          <v-form v-model="isValid">
            <!-- Residency Section -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Residency Status</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                <v-card
                  :class="['residency-option tw-cursor-pointer tw-p-6', form.residency === 'resident' ? 'tw-border-2 tw-border-primary tw-bg-blue-50' : 'tw-border']"
                  @click="form.residency = 'resident'"
                  elevation="2"
                  hover
                >
                  <div class="tw-text-center">
                    <v-icon size="48" :color="form.residency === 'resident' ? 'primary' : 'grey'" class="tw-mb-4">mdi-flag</v-icon>
                    <h4 class="tw-text-lg tw-font-bold tw-mb-2" :class="form.residency === 'resident' ? 'tw-text-primary' : ''">Kenyan Resident</h4>
                    <p class="tw-text-sm tw-text-gray-600 tw-mb-4">You hold Kenyan citizenship or permanent residence</p>
                    <v-chip v-if="form.residency === 'resident'" color="primary" size="small">Selected</v-chip>
                  </div>
                </v-card>

                <v-card
                  :class="['residency-option tw-cursor-pointer tw-p-6', form.residency === 'non-resident' ? 'tw-border-2 tw-border-primary tw-bg-blue-50' : 'tw-border']"
                  @click="form.residency = 'non-resident'"
                  elevation="2"
                  hover
                >
                  <div class="tw-text-center">
                    <v-icon size="48" :color="form.residency === 'non-resident' ? 'primary' : 'grey'" class="tw-mb-4">mdi-earth</v-icon>
                    <h4 class="tw-text-lg tw-font-bold tw-mb-2" :class="form.residency === 'non-resident' ? 'tw-text-primary' : ''">Non-Resident</h4>
                    <p class="tw-text-sm tw-text-gray-600 tw-mb-4">Foreign national or temporary visitor</p>
                    <v-chip v-if="form.residency === 'non-resident'" color="primary" size="small">Selected</v-chip>
                  </div>
                </v-card>
              </div>

              <!-- Next Step Button -->
              <v-card class="tw-mt-8">
                <v-card-text class="tw-p-6 tw-text-center">
                  <v-btn
                    @click="nextStep"
                    color="primary"
                    size="large"
                    :disabled="!form.residency"
                    class="tw-px-8"
                  >
                    <v-icon start>mdi-arrow-right</v-icon>
                    {{ form.residency === 'resident' ? 'Continue to Login' : form.residency === 'non-resident' ? 'Continue to fill out details' : 'Continue' }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

    <!-- Step 4: Authentication -->
    <div v-if="currentStep === 4" class="tw-w-full">
      <v-card class="tw-mb-8" elevation="4">
        <v-card-text class="tw-p-8">
          <!-- Resident Authentication (Force Login) -->
          <div v-if="form.residency === 'resident'" class="tw-text-center">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-mb-8">Authentication Required</h3>
            <v-icon size="80" color="primary" class="tw-mb-6">mdi-shield-lock</v-icon>
            <h4 class="tw-text-xl tw-font-bold tw-mb-4">Login Required</h4>
            <p class="tw-text-gray-600 tw-mb-8">As a Kenyan resident, please log in to continue with your travel insurance application.</p>

            <div class="tw-flex tw-justify-center tw-gap-4">
              <v-btn color="primary" size="large" @click="handleResidentLogin">
                <v-icon start>mdi-login</v-icon>
                Login to Continue
              </v-btn>
              <v-btn color="secondary" variant="outlined" size="large" @click="currentStep = 3">
                <v-icon start>mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </div>
          </div>

          <!-- Non-Resident Confirmation -->
          <div v-if="form.residency === 'non-resident'" class="tw-text-center">
            <v-icon size="80" color="primary" class="tw-mb-6">mdi-passport</v-icon>
            <h4 class="tw-text-xl tw-font-bold tw-mb-4">Non-Resident Application</h4>
            <!-- <p class="tw-text-gray-600 tw-mb-8">You will be automatically authenticated when uploading documents or making payment.</p> -->

            <div class="tw-flex tw-justify-center tw-gap-4">
              <v-btn color="primary" size="large" @click="handleNonResidentAuth">
                <v-icon start>mdi-arrow-right</v-icon>
                Continue to Personal Details
              </v-btn>
              <v-btn color="secondary" variant="outlined" size="large" @click="currentStep = 3">
                <v-icon start>mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Step 5: Personal Details -->
    <div v-if="currentStep === 5" class="tw-w-full">
      <v-card class="tw-mb-8" elevation="4">
        <v-card-text class="tw-p-8">
          <v-form v-model="isValid">
            <!-- Personal Details Section -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Personal Details</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
                <v-text-field
                  v-model="form.first_name"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="First Name"
                  :rules="[required('First Name')]"
                  @input="updateFullName"
                ></v-text-field>

                <v-text-field
                  v-model="form.last_name"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Last Name"
                  :rules="[required('Last Name')]"
                  @input="updateFullName"
                ></v-text-field>

                <v-menu
                  v-model="dateOfBirthMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateOfBirthFormatted"
                      label="Date of Birth"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="my-2 tw-px-0 md:tw-px-6"
                      :rules="[required('Date of Birth')]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.date_of_birth"
                    :max="new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().slice(0, 10)"
                    no-title
                    @input="dateOfBirthMenu = false"
                    color="primary"
                  ></v-date-picker>
                </v-menu>

                <v-text-field
                  v-model="form.email"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Email Address"
                  type="email"
                  :rules="[required('Email Address'), emailFormat()]"
                ></v-text-field>

                <v-select
                  v-model="form.gender"
                  :items="['Male', 'Female', 'Other']"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Gender"
                  :rules="[required('Gender')]"
                ></v-select>

                <v-text-field
                  v-model="form.passport_no"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Passport No."
                  :rules="[required('passport')]"
                ></v-text-field>

                <!-- Show ID and KRA PIN only for residents -->
                <v-text-field
                  v-if="form.residency === 'resident'"
                  v-model="form.id_no"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="ID No."
                  :rules="form.residency === 'resident' ? [required('idNumber'), nationalIdFormat()] : []"
                ></v-text-field>

                <v-text-field
                  v-if="form.residency === 'resident'"
                  v-model="form.kra_pin"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="KRA PIN No."
                  :rules="form.residency === 'resident' ? [required('kraPinNumber')] : []"
                ></v-text-field>
              </div>
            </div>

            <!-- Applicant/Principal Information -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Applicant Information</h3>
              <hr class="tw-mt-3 tw-mb-5">
              <p class="tw-text-gray-600 tw-mb-4 tw-px-2 md:tw-px-8">The applicant is the principal.</p>

              <div class="tw-px-2 md:tw-px-8" :class="{ 'tw-opacity-60 tw-pointer-events-none': referralFromQuery }">
                <h4 class="c-blue-text tw-text-base tw-font-semibold tw-mb-4">Are you a direct client or referred to us by an Agent?</h4>
                <v-radio-group
                  v-model="agentOption"
                  class="tw-mb-4"
                  :rules="[v => !!v || 'Selection choice is required']"
                  row
                  :disabled="referralFromQuery"
                >
                  <v-radio
                    label="Direct client"
                    :value="1"
                    class="tw-mr-8"
                  />
                  <v-radio
                    label="Referred by Agent"
                    :value="2"
                  />
                </v-radio-group>

                <!-- Agent Selection Dropdown -->
                <div v-if="agentOption === 2">
                  <v-autocomplete
                    v-model="selectedAgent"
                    :loading="agentLoading"
                    :items="agentListItems"
                    :search-input.sync="agentListSearch"
                    label="Agent"
                    variant="outlined"
                    hide-no-data
                    hide-details
                    :rules="[required('Agent')]"
                    class="tw-w-full md:tw-w-1/2"
                    :disabled="referralFromQuery"
                  />
                </div>
              </div>
            </div>


            <!-- Contact Information -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Contact Information</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                <v-text-field
                  v-model="form.mobile_main"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Mobile Number (Main)"
                  :rules="[required('Mobile Number (Main)'), isAuthenticated ? mobileFormat() : internationalMobileFormat()]"
                ></v-text-field>

                <v-text-field
                  v-model="form.mobile_alternative"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Mobile Number (Alternative)"
                ></v-text-field>
              </div>
            </div>

            <!-- Residential Address Section -->
            <div class="tw-w-full tw-mb-8">
              <v-card class="tw-mb-6" outlined elevation="2">
                <v-card-title class="c-blue-text tw-text-lg tw-bg-gray-50">
                  <v-icon class="tw-mr-2">mdi-map-marker</v-icon>
                  Residential Address
                </v-card-title>
                <v-card-text class="tw-p-6">
                  <!-- Google Maps Search -->
                  <div class="tw-mb-6">
                    <h4 class="tw-text-base tw-font-semibold tw-mb-3 tw-text-gray-700">
                      <v-icon size="small" class="tw-mr-1">mdi-google-maps</v-icon>
                      Search Address (Google)
                    </h4>
                    <v-text-field
                      ref="addressSearch"
                      id="addressSearch"
                      v-model="form.address.search_address"
                      label="Start typing your address..."
                      prepend-inner-icon="mdi-magnify"
                      variant="outlined"
                      class="tw-mb-4"
                      hint="Select from suggestions to auto-fill address fields"
                      persistent-hint
                      :rules="[required('Address')]"
                    ></v-text-field>
                  </div>

                  <!-- Postal Information Only -->
                  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    <v-text-field
                      v-model="form.address.postal_code"
                      label="Postal Code"
                      prepend-inner-icon="mdi-mailbox-outline"
                      variant="outlined"
                      class="tw-mb-2"
                      :rules="[required('Postal Code')]"
                    ></v-text-field>

                    <v-text-field
                      v-model="form.address.zip_code"
                      label="Zip Code"
                      prepend-inner-icon="mdi-numeric"
                      variant="outlined"
                      class="tw-mb-2"
                    ></v-text-field>
                  </div>

                  <!-- Hidden coordinates field for validation -->
                  <v-text-field
                    type="hidden"
                    v-model="form.address.coordinates"
                    class="tw-hidden"
                  ></v-text-field>
                </v-card-text>
              </v-card>
            </div>

            <!-- Next of Kin Section (Required) -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Next of Kin <span class="tw-text-red-500">*</span></h3>
              <hr class="tw-mt-3 tw-mb-5">

              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
                <v-text-field
                  v-model="form.next_of_kin.name"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Name *"
                  :rules="[required('Next of Kin Name')]"
                ></v-text-field>

                <v-text-field
                  v-model="form.next_of_kin.phone"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Phone Number *"
                  :rules="[required('Next of Kin Phone'), isAuthenticated ? mobileFormat() : internationalMobileFormat()]"
                ></v-text-field>

                <v-select
                  v-model="form.next_of_kin.relationship"
                  :items="relationshipOptions"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Relationship *"
                  placeholder="Select relationship"
                  :rules="[required('Relationship')]"
                  clearable
                ></v-select>
              </div>
            </div>

            <!-- Multiple Beneficiaries Section - Only for Family Plans -->
            <!-- <div v-if="selectedPlan === 'family'" class="tw-w-full tw-mb-8">
          <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Beneficiaries</h3>
          <hr class="tw-mt-3 tw-mb-5">
          <p class="tw-text-gray-600 tw-mb-4 tw-px-2 md:tw-px-8">Beneficiaries are only required for Family plans.</p>

          <div v-for="(beneficiary, index) in form.beneficiaries" :key="index" class="tw-mb-6 tw-p-4 tw-border tw-border-gray-200 tw-rounded-lg">
            <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
              <h4 class="tw-text-md tw-font-semibold">Beneficiary {{ index + 1 }}</h4>
              <v-btn
                v-if="form.beneficiaries.length > 1"
                icon
                color="error"
                @click="removeBeneficiary(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>

            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4">
              <v-text-field
                v-model="beneficiary.name"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Beneficiary Name"
              ></v-text-field>

              <v-text-field
                v-model="beneficiary.phone"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Phone Number"
              ></v-text-field>

              <v-select
                v-model="beneficiary.relationship"
                :items="relationshipOptions"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Relationship"
                placeholder="Select relationship"
                clearable
              ></v-select>

              <v-text-field
                v-model="beneficiary.percentage"
                class="my-2 tw-px-0 md:tw-px-6"
                label="Percentage (%)"
                type="number"
                min="0"
                max="100"
              ></v-text-field>
            </div>
          </div>

          <div class="tw-px-0 md:tw-px-6">
            <v-btn
              color="primary"
              outlined
              @click="addBeneficiary"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Beneficiary
            </v-btn>
          </div>
            </div> -->

            <!-- Politically Exposed Person -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Political Exposure</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <div class="tw-px-0 md:tw-px-6">
                <p class="tw-text-sm tw-text-gray-600 tw-mb-4">Are you politically exposed?</p>
                <v-radio-group
                  v-model="form.politically_exposed"
                  class="my-2"
                  :rules="[required('Political exposure status')]"
                  row
                >
                  <v-radio label="YES" value="yes" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                  <v-radio label="NO" value="no" class="tw-mt-0 md:tw-mt-5"></v-radio>
                </v-radio-group>
              </div>
            </div>

            <!-- Travel Details Section -->
            <div class="tw-w-full tw-mb-8">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Travel Details</h3>
              <hr class="tw-mt-3 tw-mb-5">

              <!-- Family Members & Beneficiaries Section - Only for Family Plan -->
              <div v-if="selectedPlan === 'family'" class="tw-w-full tw-mb-8">
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mb-3">Traveling Family Members</h3>
                <hr class="tw-mt-3 tw-mb-5">

                <div class="tw-bg-gradient-to-br tw-from-orange-50 tw-to-yellow-50 tw-rounded-xl tw-p-6 tw-mx-2 md:tw-mx-8 tw-mb-6">
                  <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
                    <div class="tw-flex tw-items-center">
                      <v-icon class="tw-mr-2" color="primary">mdi-account-group</v-icon>
                      <h4 class="c-blue-text tw-font-semibold tw-text-lg">Traveling Family Members</h4>
                    </div>
                    <v-btn
                      color="primary"
                      variant="outlined"
                      size="small"
                      @click="addBeneficiary"
                      class="tw-flex tw-items-center"
                      :disabled="!canAddMoreBeneficiaries"
                    >
                      <v-icon start>mdi-plus</v-icon>
                      Add Member
                    </v-btn>
                  </div>
              
              <p class="tw-text-gray-600 tw-text-sm tw-mb-6">
                Add family members who will be traveling and covered by this policy
              </p>

              <!-- Beneficiaries List -->
              <div v-if="form.beneficiaries && form.beneficiaries.length > 0" class="tw-space-y-4">
                <div
                  v-for="(beneficiary, index) in form.beneficiaries"
                  :key="index"
                  class="tw-bg-white tw-rounded-lg tw-border tw-border-gray-200 tw-p-4"
                >
                  <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
                    <h5 class="tw-font-semibold tw-text-gray-700">Traveler {{ index + 1 }}</h5>
                    <v-btn
                      color="error"
                      variant="text"
                      size="small"
                      @click="removeBeneficiary(index)"
                      icon
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  
                  <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                    <!-- Name -->
                    <div class="tw-space-y-2">
                      <label class="tw-text-sm tw-font-medium tw-text-gray-700">Full Name *</label>
                      <v-text-field
                        v-model="beneficiary.name"
                        placeholder="Enter full name"
                        outlined
                        dense
                        :rules="[required('Full Name')]"
                        class="my-2 tw-px-0 md:tw-px-6"
                      />
                    </div>

                    <!-- Relationship -->
                    <div class="tw-space-y-2">
                      <label class="tw-text-sm tw-font-medium tw-text-gray-700">Relationship *</label>
                      <v-select
                        v-model="beneficiary.relationship"
                        :items="getAvailableRelationships()"
                        placeholder="Select relationship"
                        outlined
                        dense
                        :rules="[required('Relationship'), relationshipValidation]"
                        class="my-2 tw-px-0 md:tw-px-6"
                      />
                    </div>

                    <!-- Phone Number -->
                    <div class="tw-space-y-2">
                      <label class="tw-text-sm tw-font-medium tw-text-gray-700">Phone Number</label>
                      <v-text-field
                        v-model="beneficiary.phone_number"
                        placeholder="+254700000000"
                        outlined
                        dense
                        prepend-icon="mdi-phone"
                        class="my-2 tw-px-0 md:tw-px-6"
                      />
                    </div>

                    <!-- Passport Number -->
                    <div class="tw-space-y-2">
                      <label class="tw-text-sm tw-font-medium tw-text-gray-700">Passport/ID Number</label>
                      <v-text-field
                        v-model="beneficiary.passport_number"
                        placeholder="Enter passport or ID number"
                        outlined
                        dense
                        prepend-icon="mdi-card-account-details"
                        class="my-2 tw-px-0 md:tw-px-6"
                      />
                    </div>

                    <!-- Date of Birth -->
                    <div class="tw-space-y-2">
                      <label class="tw-text-sm tw-font-medium tw-text-gray-700">Date of Birth</label>
                      <v-menu
                        v-model="beneficiary.dateMenu"
                        :close-on-content-click="false"
                        transition="fade-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="beneficiary.date_of_birth_formatted"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            placeholder="Select date of birth"
                            class="my-2 tw-px-0 md:tw-px-6"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="beneficiary.date_of_birth"
                          :max="maxDateString"
                          no-title
                          @input="beneficiary.dateMenu = false"
                          color="primary"
                          elevation="8"
                        ></v-date-picker>
                      </v-menu>
                    </div>

                  </div>
                </div>
              </div>

              <!-- Empty State -->
              <div v-else class="tw-text-center tw-py-8">
                <v-icon size="48" color="grey" class="tw-mb-4">mdi-account-plus</v-icon>
                <h5 class="tw-text-gray-600 tw-mb-2">No traveling family members added yet</h5>
                <p class="tw-text-gray-500 tw-text-sm tw-mb-4">Click "Add Member" to include family members who will be traveling</p>
                <v-btn
                  color="primary"
                  outlined
                  @click="addBeneficiary"
                  class="tw-flex tw-items-center"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Add First Traveler
                </v-btn>
              </div>

            </div>
          </div>

              <!-- Travel Dates Row -->
              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mb-6">
                <v-menu
                  v-model="travelStartDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="travelStartDateFormatted"
                      label="Travel Start Date *"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="my-2 tw-px-0 md:tw-px-6"
                      :rules="[required('Travel Start Date'), validateTravelStartDate]"
                      hint="Select your departure date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.travel_start_date"
                    :min="minTravelStartDate"
                    no-title
                    @input="travelStartDateMenu = false"
                    color="primary"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="travelEndDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="travelEndDateFormatted"
                      label="Travel End Date *"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      class="my-2 tw-px-0 md:tw-px-6"
                      :rules="[required('Travel End Date')]"
                      hint="Select your return date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.travel_end_date"
                    :min="form.travel_start_date || new Date().toISOString().slice(0, 10)"
                    no-title
                    @input="travelEndDateMenu = false"
                    color="primary"
                  ></v-date-picker>
                </v-menu>
              </div>


              <!-- Trip Duration Display -->
              <div v-if="form.travel_start_date && form.travel_end_date" class="tw-px-0 md:tw-px-6 tw-mt-4">
                <div class="tw-flex tw-flex-wrap tw-gap-2">
                  <!-- Trip Duration -->
                  <v-chip v-if="form.travel_start_date && form.travel_end_date" color="primary" outlined class="tw-mr-2">
                    <v-icon left>mdi-airplane</v-icon>
                    Trip Duration: {{ calculateMainTripDuration() }} days
                  </v-chip>

                  <!-- Long term warning -->
                  <v-chip v-if="calculateLongestDuration() > 365" color="warning" outlined>
                    <v-icon left>mdi-alert</v-icon>
                    Long term travel (>1 year)
                  </v-chip>
                </div>
              </div>
            </div>

            <!-- Confirm Destination Country -->
            <div class="my-2 tw-px-0 md:tw-px-6">
              <v-select
                v-model="form.destination_country"
                :items="filteredDestinationCountries"
                item-text="TRC_NAME"
                item-value="TRC_SHT_DESC"
                label="Confirm Destination Country *"
                variant="outlined"
                :rules="[required('Destination Country')]"
                clearable
                searchable
                prepend-inner-icon="mdi-map-marker"
                placeholder="Select your destination country"
              ></v-select>
              <small v-if="filteredDestinationCountries.length === 0 && !selectedRegion" class="text-warning">Please select a region first...</small>
              <small v-else-if="filteredDestinationCountries.length === 0" class="text-warning">No countries available for selected region...</small>
            </div>

        <!-- File Uploads -->
        <div class="tw-w-full tw-mb-8">
          <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Document Uploads</h3>
          <div class="tw-px-2 md:tw-px-8 tw-mb-3">
            <v-alert type="info" variant="outlined" class="tw-text-sm">
              <v-icon slot="prepend">mdi-information</v-icon>
              <strong>Required Documents:</strong>
              <span v-if="form.residency === 'resident'">
                Passport, National ID, KRA PIN, and Digital Signature are all required to proceed.
              </span>
              <span v-else>
                Passport and Digital Signature are required to proceed.
              </span>
            </v-alert>
          </div>
          <hr class="tw-mt-3 tw-mb-5">

          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4">
            <div class="my-2 tw-px-0 md:tw-px-6 tw-relative">
              <div class="tw-flex tw-items-center tw-mb-2">
                <span class="tw-font-medium tw-text-sm">Passport Upload</span>
                <v-icon v-if="documentsUploaded.passport" color="success" size="20" class="tw-ml-2">mdi-check-circle</v-icon>
                <v-icon v-else color="warning" size="20" class="tw-ml-2">mdi-clock-outline</v-icon>
              </div>
              <ExpressUpload
                :uid="form.passport_no || 'unknown'"
                :phone-number="form.mobile_main"
                :full-name="form.full_name"
                :email="form.email"
                name="Passport"
                :size="5"
                bucket="travel-policies"
                :travel-type="isAuthenticated ? 'pacis' : 'non-resident'"
                document-type="passport"
                :id-number="form.id_no || form.passport_no"
                :kra-pin="form.kra_pin"
                @upload-success="onUploadSuccess"
              />
            </div>

            <!-- Show ID and KRA PIN uploads only for residents -->
            <div v-if="form.residency === 'resident'" class="my-2 tw-px-0 md:tw-px-6 tw-relative">
              <div class="tw-flex tw-items-center tw-mb-2">
                <span class="tw-font-medium tw-text-sm">National ID Upload</span>
                <v-icon v-if="documentsUploaded.idNumber" color="success" size="20" class="tw-ml-2">mdi-check-circle</v-icon>
                <v-icon v-else color="warning" size="20" class="tw-ml-2">mdi-clock-outline</v-icon>
              </div>
              <ExpressUpload
                :uid="form.id_no || 'unknown'"
                :kra-pin="form.kra_pin"
                :id-number="form.id_no"
                :phone-number="form.mobile_main"
                :full-name="form.full_name"
                :email="form.email"
                name="National ID"
                bucket="travel-policies"
                travel-type="pacis"
                document-type="idNumber"
                :size="5"
                @upload-success="onUploadSuccess"
              />
            </div>

            <div v-if="form.residency === 'resident'" class="my-2 tw-px-0 md:tw-px-6 tw-relative">
              <div class="tw-flex tw-items-center tw-mb-2">
                <span class="tw-font-medium tw-text-sm">KRA PIN Upload</span>
                <v-icon v-if="documentsUploaded.kraPin" color="success" size="20" class="tw-ml-2">mdi-check-circle</v-icon>
                <v-icon v-else color="warning" size="20" class="tw-ml-2">mdi-clock-outline</v-icon>
              </div>
              <ExpressUpload
                :uid="form.kra_pin || 'unknown'"
                :kra-pin="form.kra_pin"
                :id-number="form.id_no"
                :phone-number="form.mobile_main"
                :full-name="form.full_name"
                :email="form.email"
                name="KRA PIN"
                bucket="travel-policies"
                travel-type="pacis"
                document-type="kraPinNumber"
                :size="5"
                @upload-success="onUploadSuccess"
              />
            </div>
            <!-- Digital Signature Upload (for all users) -->
            <div class="my-2 tw-px-0 md:tw-px-6 tw-relative">
              <div class="tw-flex tw-items-center tw-mb-2">
                <span class="tw-font-medium tw-text-sm">Digital Signature Upload</span>
                <v-icon v-if="documentsUploaded.signature" color="success" size="20" class="tw-ml-2">mdi-check-circle</v-icon>
                <v-icon v-else color="warning" size="20" class="tw-ml-2">mdi-clock-outline</v-icon>
              </div>
              <ExpressUpload
                :uid="form.id_no || form.passport_no || 'unknown'"
                :kra-pin="form.kra_pin"
                :id-number="form.id_no || form.passport_no"
                :phone-number="form.mobile_main"
                :full-name="form.full_name"
                :email="form.email"
                name="Digital Signature"
                bucket="travel-policies"
                :travel-type="isAuthenticated ? 'pacis' : 'non-resident'"
                document-type="signature"
                :size="5"
                @upload-success="onUploadSuccess"
              />
            </div>
          </div>
        </div>

        <!-- Declaration and Consent -->
        <div class="tw-w-full tw-mb-8">
          <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Declaration & Consent</h3>
          <hr class="tw-mt-3 tw-mb-5">

          <div class="tw-px-0 md:tw-px-6">
            <v-checkbox
              v-model="form.declaration"
              :rules="[check()]"
              class="my-2"
            >
              <template v-slot:label>
                <div class="tw-text-sm">
                  <strong>DECLARATION:</strong> I/We declare that to my/our knowledge that the answers and particulars given in this Proposal Form are true and complete and that I/we have not withheld any material information. I/We have also read and understood that this Proposal Form and Declaration shall be the basis of the Contract between me/us and PACIS Insurance Company Limited.
                </div>
              </template>
            </v-checkbox>

            <v-checkbox
              v-model="form.data_privacy"
              :rules="[check()]"
              class="my-2"
            >
              <template v-slot:label>
                <div class="tw-text-sm">
                  <strong>DATA PRIVACY:</strong> I/We willingly provide my/our personal information in this Proposal Form and consent its use as prescribed in the Pacis Insurance Data Protection Policy (The policy is available on our website www.pacisinsurance.com) and in accordance with Data Protection Act, 2019.
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>

        <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
          <v-btn
            block
            large
            color="primary"
            class="my-3"
            @click="proceedToPayment"
            :disabled="!isValid || !areRequiredDocumentsUploaded"
          >
            {{ (isValid && areRequiredDocumentsUploaded) ? 'Proceed to Get Quote' : (!areRequiredDocumentsUploaded ? 'Please upload all required documents' : 'Please fill all required fields') }}
          </v-btn>
        </v-card-actions>
        </v-form>
        </v-card-text>
      </v-card>
    </div>

    <!-- Step 6: Payment -->
    <div v-if="currentStep === 6" class="tw-w-full">
      <v-card class="tw-mb-8" elevation="4">
        <v-card-text class="tw-p-8">
          <div class="tw-text-center">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-mb-8">Payment Processing</h3>
            <v-icon size="80" color="success" class="tw-mb-6">mdi-check-circle</v-icon>
            <h4 class="tw-text-xl tw-font-bold tw-mb-4">Application Completed!</h4>
            <p class="tw-text-gray-600 tw-mb-8">Your travel insurance application has been submitted. You will receive payment instructions shortly.</p>

            <v-btn color="primary" size="large" @click="currentStep = 1">
              <v-icon start>mdi-home</v-icon>
              Start New Application
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import validations from '@/utils/validations';
import axios from 'axios';
import { mapGetters } from 'vuex';
import ExpressUpload from '@/components/shared/ExpressUpload';
import exchangeRates from '@/config/exchangeRates';
import { TravelPolicyService } from '@/services/TravelPolicyService';
import { travelPaymentReference } from '@/utils/travelPaymentReference';
import { getReferralAgentCode, validateReferralCode } from '@/services/referralApi';

const { Loader } = require('google-maps');

const options = { version: '3.40', language: 'en', libraries: ['places'] };
const loader = new Loader(process.env.VUE_APP_GOOGLE_MAPS_API_KEY, options);

const TRAVEL_QUOTES_API = '/customer/digital-quotation/pacis-travel/quotes';

// Constants for regions to avoid duplication
const REGION_AFRICA = 'Africa';
const REGION_ASIA = 'Asia';
const VALIDATION_ERROR = 'Validation Error';

// Vuex mutation constants
const SET_TRAVEL_QUOTE_RESPONSE = 'rfq/setTravelQuoteResponse';

// const destinationCountries = TravelPolicyService.getDestinationCountries();
// console.info('Destination countries loaded:', destinationCountries.length, 'countries');

export default {
  name: 'StartTravel',
  components: {
    ExpressUpload,
  },
  data() {
    return {
      ...validations,
      // Enhanced flow data
      currentStep: 1,
      selectedPlan: 'individual',
      buyingFor: 'myself', // 'myself' or 'someone_else'
      emailAddress: '',
      emailError: '',
      birthDate: '',
      selectedRegion: '',
      selectedCountry: '',
      selectedDuration: '',
      // Saved quotes removed from initial quotation process
      loadingPrice: false,
      loadingBuyNow: false,
      currentQuote: null,
      currentQuoteId: null,

      // Agent selection data
      agentOption: 1,
      agentList: [],
      selectedAgent: null,
      agentListSearch: null,
      agentListItems: [],
      agentLoading: false,
      referralAgent: null,
      referralFromQuery: false,

      // Beneficiaries and relationship options for family plans
      relationshipOptions: ['Spouse', 'Child', 'Parent', 'Sibling', 'Other'],

      // Non-resident authentication (will be handled automatically during upload/payment)
      nonResidentToken: null,

      // Google Maps loading flag
      loaded: false,

      // Date picker menu states
      birthDateMenu: false,
      dateOfBirthMenu: false,
      travelStartDateMenu: false,
      travelEndDateMenu: false,

      stepItems: [
        { title: 'Plan Selection', value: 1 },
        { title: 'Quote Details', value: 2 },
        { title: 'Residency', value: 3 },
        { title: 'Authentication', value: 4 },
        { title: 'Personal Details', value: 5 },
        { title: 'Payment', value: 6 },
      ],

      form: {
        residency: '',
        first_name: '',
        last_name: '',
        full_name: '',
        date_of_birth: '',
        email: '',
        gender: '',
        passport_no: '',
        id_no: '',
        kra_pin: '',
        address: {
          area: '',
          street: '',
          po_box: '',
          postal_code: '',
          zip_code: '',
          city: '',
          search_address: '',
          coordinates: null,
        },
        mobile_main: '',
        mobile_alternative: '',
        next_of_kin: {
          name: '',
          phone: '',
          relationship: '',
        },
        beneficiaries: [
          {
            name: '',
            phone: '',
            relationship: '',
            percentage: '',
          },
        ],
        politically_exposed: '',
        travel_start_date: '',
        travel_end_date: '',
        destination_country: '',
        travel_plan: '',
        declaration: false,
        data_privacy: false,
      },
      isValid: false,

      // Document upload tracking - all required for travel insurance
      documentsUploaded: {
        passport: false,
        signature: false,
        idNumber: false,
        kraPin: false,
      },

    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
    travel_plans() {
      return [
        {
          type: 'DOMESTIC Travel',
          limit: 5000,
          value: 'domestic',
          label: 'DOMESTIC Travel - $5,000',
        },
        {
          type: 'AFRICA - Individual',
          limit: 15000,
          value: 'africa',
          label: 'AFRICA - Individual - $15,000',
        },
        {
          type: 'ASIA - Individual',
          limit: 15000,
          value: 'asia',
          label: 'ASIA - Individual - $15,000',
        },
        {
          type: 'EUROPE (Schengen) - Individual',
          limit: 40000,
          value: 'europe_schengen',
          label: 'EUROPE (Schengen) - Individual - $40,000',
        },
        {
          type: 'EUROPE Plus (Schengen) - Individual',
          limit: 80000,
          value: 'europe_plus',
          label: 'EUROPE Plus (Schengen) - Individual - $80,000',
        },
        {
          type: 'WORLDWIDE Basic - Individual',
          limit: 40000,
          value: 'worldwide_basic',
          label: 'WORLDWIDE Basic - Individual - $40,000',
        },
        {
          type: 'WORLDWIDE Premium - Individual',
          limit: 75000,
          value: 'worldwide_premium',
          label: 'WORLDWIDE Premium - Individual - $75,000',
        },
        {
          type: 'WORLDWIDE Extra - Individual',
          limit: 150000,
          value: 'worldwide_extra',
          label: 'WORLDWIDE Extra - Individual - $150,000',
        },
        {
          type: 'CORPORATE Travel',
          limit: 300000,
          value: 'corporate',
          label: 'CORPORATE Travel - $300,000',
        },
        {
          type: 'STUDENTS Classic',
          limit: 60000,
          value: 'students_classic',
          label: 'STUDENTS Classic - $60,000',
        },
        {
          type: 'STUDENTS Premium',
          limit: 100000,
          value: 'students_premium',
          label: 'STUDENTS Premium - $100,000',
        },
        {
          type: 'INBOUND Travel',
          limit: 130000,
          value: 'inbound',
          label: 'INBOUND Travel - $130,000',
        },
      ];
    },
    beneficiariesValid() {
      // For individual and student plans, always valid since beneficiaries are not used
      if (this.selectedPlan === 'individual' || this.selectedPlan === 'student') {
        return true;
      }
      // For family plans, check relationship limits
      return this.validateFamilyComposition();
    },

    validateFamilyComposition() {
      if (!this.form.beneficiaries || this.form.beneficiaries.length === 0) {
        return true; // Empty is valid
      }

      const spouseCount = this.form.beneficiaries.filter((b) => b.relationship === 'Spouse').length;
      const childrenCount = this.form.beneficiaries.filter((b) => b.relationship === 'Child').length;

      return spouseCount <= 1 && childrenCount <= 3;
    },

    canAddMoreBeneficiaries() {
      if (!this.form.beneficiaries) return true;

      const spouseCount = this.form.beneficiaries.filter((b) => b.relationship === 'Spouse').length;
      const childrenCount = this.form.beneficiaries.filter((b) => b.relationship === 'Child').length;

      // Can add more if we haven't reached the limits
      return spouseCount < 1 || childrenCount < 3;
    },

    // Enhanced flow computed properties
    maxDateString() {
      const maxDate = new Date();
      // For Individual plan with "buying for someone else" option
      if (this.selectedPlan === 'individual' && this.buyingFor === 'someone_else') {
        // For someone else, minimum age 1
        maxDate.setFullYear(maxDate.getFullYear() - 1);
      } else {
        // For principal applicant (myself) or Family/Student plans, minimum age 18
        maxDate.setFullYear(maxDate.getFullYear() - 18);
      }
      return maxDate.toISOString().split('T')[0];
    },

    minDateString() {
      const minDate = new Date();
      minDate.setFullYear(minDate.getFullYear() - 85); // Maximum age 85
      return minDate.toISOString().split('T')[0];
    },

    isApplicantOldEnough() {
      if (!this.birthDate) return true; // Allow empty for now
      const age = this.calculateAge(this.birthDate);

      // For Individual plan with "buying for someone else" option
      if (this.selectedPlan === 'individual' && this.buyingFor === 'someone_else') {
        return age >= 1; // For someone else, minimum age 1
      }

      // For principal applicant (myself) or Family/Student plans, minimum age 18
      return age >= 18;
    },

    price() {
      if (!this.currentQuote) return null;

      return {
        base: this.currentQuote.base_price,
        revised: this.currentQuote.age_adjusted_price || this.currentQuote.premium,
      };
    },

    canGetPrice() {
      return !!(this.selectedRegion && this.selectedPlan && this.birthDate && this.emailAddress && this.form.full_name && this.form.passport_no);
    },

    // filteredQuotes computed property removed - saved quotes are now handled in SavedQuotes page

    regions() {
      const studentRegions = this.studentRegions || [];
      const standardRegions = this.standardRegions || [];
      return this.selectedPlan === 'student' ? studentRegions : standardRegions;
    },

    durations() {
      const studentDurations = this.studentDurations || [];
      const standardDurations = this.standardDurations || [];
      return this.selectedPlan === 'student' ? studentDurations : standardDurations;
    },

    standardRegions() {
      const EUROPE = 'Europe';
      const WORLDWIDE_PREFIX = 'Worldwide';
      const WORLDWIDE_BASIC = `${WORLDWIDE_PREFIX} Basic`;
      const WORLDWIDE_PREMIUM = `${WORLDWIDE_PREFIX} Premium`;
      const WORLDWIDE_EXTRA = `${WORLDWIDE_PREFIX} Extra`;
      const COVERAGE_TEXT = 'coverage';

      return [
        { value: REGION_AFRICA, label: REGION_AFRICA, description: `Most affordable ${COVERAGE_TEXT}` },
        { value: REGION_ASIA, label: REGION_ASIA, description: `Most affordable ${COVERAGE_TEXT}` },
        { value: EUROPE, label: EUROPE, description: `Mid-range ${COVERAGE_TEXT}` },
        { value: WORLDWIDE_BASIC, label: WORLDWIDE_BASIC, description: `Comprehensive global ${COVERAGE_TEXT}` },
        { value: WORLDWIDE_PREMIUM, label: WORLDWIDE_PREMIUM, description: `Enhanced worldwide ${COVERAGE_TEXT}` },
        { value: WORLDWIDE_EXTRA, label: WORLDWIDE_EXTRA, description: `Premium worldwide ${COVERAGE_TEXT}` },
      ];
    },

    studentRegions() {
      const WORLDWIDE_PREFIX = 'Worldwide';
      const WORLDWIDE_CLASSIC = `${WORLDWIDE_PREFIX} Classic`;
      const WORLDWIDE_PREMIUM = `${WORLDWIDE_PREFIX} Premium`;
      const WORLDWIDE_TEXT = 'worldwide';
      const STUDENTS_TEXT = 'for students';

      return [
        { value: WORLDWIDE_CLASSIC, label: WORLDWIDE_CLASSIC, description: `Essential ${WORLDWIDE_TEXT} coverage ${STUDENTS_TEXT}` },
        { value: WORLDWIDE_PREMIUM, label: WORLDWIDE_PREMIUM, description: `Enhanced ${WORLDWIDE_TEXT} coverage ${STUDENTS_TEXT}` },
      ];
    },

    standardDurations() {
      const DAYS_1_4 = '1-4 days';
      const DAYS_5_7 = '5-7 days';
      const DAYS_8_10 = '8-10 days';
      const DAYS_11_15 = '11-15 days';
      const DAYS_16_21 = '16-21 days';
      const DAYS_22_30 = '22-30 days';
      const DAYS_31_60 = '31-60 days';
      const DAYS_61_90 = '61-90 days';
      const DAYS_91_180 = '91-180 days';
      const YEAR_TRIP = '1 year trip';

      return [
        { value: DAYS_1_4, label: DAYS_1_4, description: 'Short trips' },
        { value: DAYS_5_7, label: DAYS_5_7, description: 'Week-long trips' },
        { value: DAYS_8_10, label: DAYS_8_10, description: 'Extended week' },
        { value: DAYS_11_15, label: DAYS_11_15, description: 'Two weeks' },
        { value: DAYS_16_21, label: DAYS_16_21, description: 'Three weeks' },
        { value: DAYS_22_30, label: DAYS_22_30, description: 'One month' },
        { value: DAYS_31_60, label: DAYS_31_60, description: 'Two months' },
        { value: DAYS_61_90, label: DAYS_61_90, description: 'Three months' },
        { value: DAYS_91_180, label: DAYS_91_180, description: 'Six months' },
        { value: YEAR_TRIP, label: YEAR_TRIP, description: 'Annual coverage' },
      ];
    },

    studentDurations() {
      return [
        { value: '6 months', label: '6 months', description: 'Maximum 180 consecutive days' },
        { value: '9 months', label: '9 months', description: 'Maximum 270 consecutive days' },
        { value: '1 year', label: '1 year', description: 'Maximum 365 consecutive days' },
      ];
    },

    selectedRegionDisplay() {
      if (!this.selectedRegion) return '';
      const region = this.regions?.find((r) => r?.value === this.selectedRegion);
      return region?.label || this.selectedRegion || '';
    },

    selectedDurationDisplay() {
      if (!this.selectedDuration) return '';
      const duration = this.durations?.find((d) => d?.value === this.selectedDuration);
      return duration?.label || this.selectedDuration || '';
    },

    // Filter destination countries based on selected region
    filteredDestinationCountries() {
      if (!this.selectedRegion) {
        return this.getDestinationCountries();
      }

      const allCountries = this.getDestinationCountries();
      let zoneCode;

      // Define constants for worldwide regions
      /* eslint-disable sonarjs/no-duplicate-string */
      const WORLDWIDE_BASIC = 'Worldwide Basic';
      const WORLDWIDE_PREMIUM = 'Worlwide Premium';
      const WORLDWIDE_EXTRA = 'Worldwide Extra';

      // Map regions to zone codes
      switch (this.selectedRegion) {
        case REGION_AFRICA:
          zoneCode = 1; // African countries
          break;
        case REGION_ASIA:
          zoneCode = 2; // Asian countries
          break;
        case 'Europe':
          zoneCode = 4; // European countries
          break;
        case WORLDWIDE_BASIC:
        case WORLDWIDE_PREMIUM:
        case WORLDWIDE_EXTRA:
          zoneCode = 3; // Americas and Oceania countries
          break;
        default:
          return allCountries; // Return all countries if region not matched
      }

      return allCountries.filter((country) => country.TRC_TRZ_CODE === zoneCode);
    },

    // Formatted date computed properties for display
    birthDateFormatted() {
      return this.formatDate(this.birthDate);
    },
    dateOfBirthFormatted() {
      return this.formatDate(this.form.date_of_birth);
    },
    travelStartDateFormatted() {
      return this.formatDate(this.form.travel_start_date);
    },
    travelEndDateFormatted() {
      return this.formatDate(this.form.travel_end_date);
    },
    exchangeRate() {
      return exchangeRates.getUsdToKshRate();
    },

    // Minimum date for travel start (48 hours from now)
    minTravelStartDate() {
      const now = new Date();
      now.setHours(now.getHours() + 48);
      return now.toISOString().slice(0, 10);
    },

    // Check if all required documents are uploaded
    areRequiredDocumentsUploaded() {
      // Passport and signature are required for all users
      const basicRequirements = this.documentsUploaded.passport && this.documentsUploaded.signature;

      // For residents, also require ID number and KRA PIN uploads
      if (this.form.residency === 'resident') {
        return basicRequirements && this.documentsUploaded.idNumber && this.documentsUploaded.kraPin;
      }

      // For non-residents, only passport and signature are required
      return basicRequirements;
    },

  },
  async mounted() {
    try {
      this.autofillUserData();

      // Debug: Check dropdown data
      // console.log('Component mounted - selectedPlan:', this.selectedPlan);
      // console.log('standardRegions:', this.standardRegions);
      // console.log('regions computed:', this.regions);
      // console.log('durations computed:', this.durations);
      this.getAgentList();
      const agentCode = getReferralAgentCode(this.$route.query);
      if (agentCode) {
        validateReferralCode(agentCode).then((result) => {
          if (result) {
            this.referralAgent = result;
            this.referralFromQuery = true;
            this.applyReferralAgent();
          }
        });
      }
    } catch (error) {
      // console.error('Error during component initialization:', error);
      this.$toast.warning('Some features may not work properly. Please refresh the page if you experience issues.', 'Initialization Warning');
    }
  },

  updated() {
    const ref = this;
    this.$nextTick(() => {
      if (typeof ref.$refs.addressSearch !== 'undefined' && !this.loaded) {
        ref.initializeGooglePlaces();
      }
    });
  },

  watch: {
    form: {
      deep: true,
      handler() {
        // Auto-update travel context when form changes
        this.updateTravelContext();
      },
    },

    async agentListSearch(val) {
      if (this.referralFromQuery) return;
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.agentList && this.agentListFilter(val);
    },

    buyingFor(newVal, oldVal) {
      // Only applies to Individual plans
      if (this.selectedPlan === 'individual' && newVal !== oldVal && this.birthDate) {
        // Clear birth date when switching between myself/someone else to force revalidation
        const age = this.calculateAge(this.birthDate);

        // If switching from "someone_else" to "myself" and age is less than 18, clear the date
        if (newVal === 'myself' && age < 18) {
          this.birthDate = '';
          this.form.date_of_birth = '';
        }
        // If switching from "myself" to "someone_else", keep the existing valid date

        // Trigger form validation
        this.$nextTick(() => {
          if (this.$refs.birthDateField) {
            this.$refs.birthDateField.validate();
          }
        });
      }
    },

    selectedPlan(newPlan, oldPlan) {
      // Reset selections when changing between plans
      this.selectedRegion = '';
      this.selectedDuration = '';
      this.currentQuote = null;

      // Reset buyingFor when switching away from Individual plan
      if (oldPlan === 'individual' && newPlan !== 'individual') {
        this.buyingFor = 'myself';
      }

      // For Family and Student plans, always set to 'myself' since "buying for someone else" doesn't apply
      if (newPlan === 'family' || newPlan === 'student') {
        this.buyingFor = 'myself';
      }
    },

    // Auto-calculate end date when start date or duration changes
    'form.travel_start_date': function onTravelStartDateChange() {
      this.autoCalculateEndDate();
    },

    selectedDuration() {
      this.autoCalculateEndDate();
    },

    // Watch for document upload changes to update validation message
    areRequiredDocumentsUploaded() {
      // This computed property change will trigger UI updates for the button text
      // console.log('Required documents uploaded status changed:', this.areRequiredDocumentsUploaded);
    },
  },
  methods: {
    updateTravelContext() {
      // Save form data to travel context using the service method
      TravelPolicyService.setTravelContext(this.$store, this.form, this.authenticatedUser);
    },

    ageValidation(value) {
      if (!value) return true; // Required validation is handled separately
      const age = this.calculateAge(value);

      // For Individual plan with "buying for someone else" option
      if (this.selectedPlan === 'individual' && this.buyingFor === 'someone_else') {
        if (age < 1) {
          return 'Traveller must be at least 1 year old';
        }
      } else if (age < 18) {
        // For principal applicant (myself) or Family/Student plans
        return 'Principal applicant must be at least 18 years old';
      }

      if (age > 90) {
        return 'Maximum age limit is 90 years';
      }
      return true;
    },

    // Beneficiary management methods
    addBeneficiary() {
      if (!this.form.beneficiaries) {
        this.$set(this.form, 'beneficiaries', []);
      }

      const newBeneficiary = {
        name: '',
        relationship: '',
        phone_number: '',
        passport_number: '',
        date_of_birth: '',
        date_of_birth_formatted: '',
        dateMenu: false,
      };

      this.form.beneficiaries.push(newBeneficiary);
    },

    removeBeneficiary(index) {
      if (this.form.beneficiaries && index >= 0 && index < this.form.beneficiaries.length) {
        this.form.beneficiaries.splice(index, 1);
      }
    },

    getAvailableRelationships() {
      if (!this.form.beneficiaries || this.form.beneficiaries.length === 0) {
        return this.relationshipOptions;
      }

      const spouseCount = this.form.beneficiaries.filter((b) => b.relationship === 'Spouse').length;
      const childrenCount = this.form.beneficiaries.filter((b) => b.relationship === 'Child').length;

      const available = [];

      // Allow spouse if none exists yet
      if (spouseCount < 1) {
        available.push('Spouse');
      }

      // Allow children if less than 3
      if (childrenCount < 3) {
        available.push('Child');
      }

      return available;
    },

    relationshipValidation(value) {
      if (!value) return true; // Required validation is handled separately

      if (!this.form.beneficiaries) return true;

      const spouseCount = this.form.beneficiaries.filter((b) => b.relationship === 'Spouse').length;
      const childrenCount = this.form.beneficiaries.filter((b) => b.relationship === 'Child').length;

      if (value === 'Spouse' && spouseCount > 1) {
        return 'Only one spouse is allowed';
      }

      if (value === 'Child' && childrenCount > 3) {
        return 'Maximum of 3 children allowed';
      }

      return true;
    },

    validateTravelStartDate(value) {
      if (!value) return true; // Required validation is handled separately
      const selectedDate = new Date(value);
      const minDate = new Date();
      minDate.setHours(minDate.getHours() + 48);
      if (selectedDate < minDate) {
        return 'Travel start date must be at least 48 hours from now';
      }
      return true;
    },

    onUploadSuccess(data) {
      // console.log('Document uploaded successfully:', data);

      // Track which documents have been uploaded
      const { documentType } = data;
      if (documentType === 'passport') {
        this.documentsUploaded.passport = true;
      } else if (documentType === 'signature') {
        this.documentsUploaded.signature = true;
      } else if (documentType === 'idNumber') {
        this.documentsUploaded.idNumber = true;
      } else if (documentType === 'kraPinNumber') {
        this.documentsUploaded.kraPin = true;
      }

      // console.log('Documents uploaded status:', this.documentsUploaded);
    },

    formatDate(date) {
      if (!date) return '';
      // Format date for display (YYYY-MM-DD to readable format)
      const dateObj = new Date(date);
      if (Number.isNaN(dateObj.getTime())) return '';
      return dateObj.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },

    formatPrice(price) {
      if (!price) return '0';
      if (typeof price === 'object' && price.revised) {
        return Number(price.revised).toLocaleString();
      }
      return Number(price).toLocaleString();
    },

    formatPriceKSH(price) {
      if (!price) return '0';
      let usdAmount = 0;
      if (typeof price === 'object' && price.revised) {
        usdAmount = Number(price.revised);
      } else {
        usdAmount = Number(price);
      }
      // Convert USD to KSH using centralized exchange rate
      const kshAmount = exchangeRates.convertUsdToKsh(usdAmount);
      return kshAmount.toLocaleString();
    },

    getDestinationCountries() {
      const countries = [
        { TRC_SHT_DESC: 'DZ', TRC_NAME: 'ALGERIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'AO', TRC_NAME: 'ANGOLA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'BJ', TRC_NAME: 'BENIN', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'BW', TRC_NAME: 'BOTSWANA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'BF', TRC_NAME: 'BURKINA FASO', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'BI', TRC_NAME: 'BURUNDI', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CM', TRC_NAME: 'CAMEROON', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CV', TRC_NAME: 'CAPE VERDE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CF', TRC_NAME: 'CENTRAL AFRICAN REPUBLIC', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'TD', TRC_NAME: 'CHAD', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'KM', TRC_NAME: 'COMOROS', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CG', TRC_NAME: 'CONGO', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CD', TRC_NAME: 'CONGO (DEMOCRATIC REPUBLIC)', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'CI', TRC_NAME: 'COTE D\'IVOIRE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'DJ', TRC_NAME: 'DJIBOUTI', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'EG', TRC_NAME: 'EGYPT', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GQ', TRC_NAME: 'EQUATORIAL GUINEA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ER', TRC_NAME: 'ERITREA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ET', TRC_NAME: 'ETHIOPIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GA', TRC_NAME: 'GABON', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GM', TRC_NAME: 'GAMBIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GH', TRC_NAME: 'GHANA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GN', TRC_NAME: 'GUINEA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'GW', TRC_NAME: 'GUINEA-BISSAU', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'KE', TRC_NAME: 'KENYA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'LS', TRC_NAME: 'LESOTHO', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'LR', TRC_NAME: 'LIBERIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'LY', TRC_NAME: 'LIBYA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MG', TRC_NAME: 'MADAGASCAR', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MW', TRC_NAME: 'MALAWI', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ML', TRC_NAME: 'MALI', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MR', TRC_NAME: 'MAURITANIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MU', TRC_NAME: 'MAURITIUS', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'YT', TRC_NAME: 'MAYOTTE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MA', TRC_NAME: 'MOROCCO', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'MZ', TRC_NAME: 'MOZAMBIQUE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'NA', TRC_NAME: 'NAMIBIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'NE', TRC_NAME: 'NIGER', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'NG', TRC_NAME: 'NIGERIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'RE', TRC_NAME: 'REUNION', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'RW', TRC_NAME: 'RWANDA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ST', TRC_NAME: 'SAO TOME AND PRINCIPE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SN', TRC_NAME: 'SENEGAL', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SC', TRC_NAME: 'SEYCHELLES', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SL', TRC_NAME: 'SIERRA LEONE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SO', TRC_NAME: 'SOMALIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ZA', TRC_NAME: 'SOUTH AFRICA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SS', TRC_NAME: 'SOUTH SUDAN', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SD', TRC_NAME: 'SUDAN', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'SZ', TRC_NAME: 'ESWATINI (SWAZILAND)', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'TZ', TRC_NAME: 'TANZANIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'TG', TRC_NAME: 'TOGO', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'TN', TRC_NAME: 'TUNISIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'UG', TRC_NAME: 'UGANDA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ZM', TRC_NAME: 'ZAMBIA', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'ZW', TRC_NAME: 'ZIMBABWE', TRC_TRZ_CODE: 1 },
        { TRC_SHT_DESC: 'AF', TRC_NAME: 'AFGHANISTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'AM', TRC_NAME: 'ARMENIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'AZ', TRC_NAME: 'AZERBAIJAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'BH', TRC_NAME: 'BAHRAIN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'BD', TRC_NAME: 'BANGLADESH', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'BT', TRC_NAME: 'BHUTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'BN', TRC_NAME: 'BRUNEI', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KH', TRC_NAME: 'CAMBODIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'CN', TRC_NAME: 'CHINA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'GE', TRC_NAME: 'GEORGIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'HK', TRC_NAME: 'HONG KONG', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'IN', TRC_NAME: 'INDIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'ID', TRC_NAME: 'INDONESIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'IR', TRC_NAME: 'IRAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'IQ', TRC_NAME: 'IRAQ', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'IL', TRC_NAME: 'ISRAEL', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'JP', TRC_NAME: 'JAPAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'JO', TRC_NAME: 'JORDAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KZ', TRC_NAME: 'KAZAKHSTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KW', TRC_NAME: 'KUWAIT', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KG', TRC_NAME: 'KYRGYZSTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'LA', TRC_NAME: 'LAOS', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'LB', TRC_NAME: 'LEBANON', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'MO', TRC_NAME: 'MACAU', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'MY', TRC_NAME: 'MALAYSIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'MV', TRC_NAME: 'MALDIVES', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'MN', TRC_NAME: 'MONGOLIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'MM', TRC_NAME: 'MYANMAR (BURMA)', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'NP', TRC_NAME: 'NEPAL', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KP', TRC_NAME: 'NORTH KOREA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'OM', TRC_NAME: 'OMAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'PK', TRC_NAME: 'PAKISTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'PS', TRC_NAME: 'PALESTINE', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'PH', TRC_NAME: 'PHILIPPINES', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'QA', TRC_NAME: 'QATAR', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'SA', TRC_NAME: 'SAUDI ARABIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'SG', TRC_NAME: 'SINGAPORE', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'KR', TRC_NAME: 'SOUTH KOREA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'LK', TRC_NAME: 'SRI LANKA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'SY', TRC_NAME: 'SYRIA', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TW', TRC_NAME: 'TAIWAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TJ', TRC_NAME: 'TAJIKISTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TH', TRC_NAME: 'THAILAND', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TL', TRC_NAME: 'TIMOR-LESTE', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TR', TRC_NAME: 'TURKEY', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'TM', TRC_NAME: 'TURKMENISTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'AE', TRC_NAME: 'UNITED ARAB EMIRATES', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'UZ', TRC_NAME: 'UZBEKISTAN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'VN', TRC_NAME: 'VIETNAM', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'YE', TRC_NAME: 'YEMEN', TRC_TRZ_CODE: 2 },
        { TRC_SHT_DESC: 'US', TRC_NAME: 'UNITED STATES', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CA', TRC_NAME: 'CANADA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'MX', TRC_NAME: 'MEXICO', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BZ', TRC_NAME: 'BELIZE', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CR', TRC_NAME: 'COSTA RICA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'SV', TRC_NAME: 'EL SALVADOR', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'GT', TRC_NAME: 'GUATEMALA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'HN', TRC_NAME: 'HONDURAS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'NI', TRC_NAME: 'NICARAGUA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PA', TRC_NAME: 'PANAMA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AI', TRC_NAME: 'ANGUILLA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AG', TRC_NAME: 'ANTIGUA AND BARBUDA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AW', TRC_NAME: 'ARUBA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BS', TRC_NAME: 'BAHAMAS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BB', TRC_NAME: 'BARBADOS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BM', TRC_NAME: 'BERMUDA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'VG', TRC_NAME: 'BRITISH VIRGIN ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'KY', TRC_NAME: 'CAYMAN ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CU', TRC_NAME: 'CUBA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CW', TRC_NAME: 'CURACAO', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'DM', TRC_NAME: 'DOMINICA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'DO', TRC_NAME: 'DOMINICAN REPUBLIC', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'GD', TRC_NAME: 'GRENADA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'GP', TRC_NAME: 'GUADELOUPE', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'HT', TRC_NAME: 'HAITI', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'JM', TRC_NAME: 'JAMAICA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'MQ', TRC_NAME: 'MARTINIQUE', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'MS', TRC_NAME: 'MONTSERRAT', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PR', TRC_NAME: 'PUERTO RICO', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'KN', TRC_NAME: 'SAINT KITTS AND NEVIS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'LC', TRC_NAME: 'SAINT LUCIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'VC', TRC_NAME: 'SAINT VINCENT AND THE GRENADINES', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'TT', TRC_NAME: 'TRINIDAD AND TOBAGO', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'TC', TRC_NAME: 'TURKS AND CAICOS ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'VI', TRC_NAME: 'US VIRGIN ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AR', TRC_NAME: 'ARGENTINA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BO', TRC_NAME: 'BOLIVIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'BR', TRC_NAME: 'BRAZIL', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CL', TRC_NAME: 'CHILE', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CO', TRC_NAME: 'COLOMBIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'EC', TRC_NAME: 'ECUADOR', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'FK', TRC_NAME: 'FALKLAND ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'GF', TRC_NAME: 'FRENCH GUIANA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'GY', TRC_NAME: 'GUYANA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PY', TRC_NAME: 'PARAGUAY', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PE', TRC_NAME: 'PERU', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'SR', TRC_NAME: 'SURINAME', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'UY', TRC_NAME: 'URUGUAY', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'VE', TRC_NAME: 'VENEZUELA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AU', TRC_NAME: 'AUSTRALIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'NZ', TRC_NAME: 'NEW ZEALAND', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'FJ', TRC_NAME: 'FIJI', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PG', TRC_NAME: 'PAPUA NEW GUINEA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'NC', TRC_NAME: 'NEW CALEDONIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PF', TRC_NAME: 'FRENCH POLYNESIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'SB', TRC_NAME: 'SOLOMON ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'VU', TRC_NAME: 'VANUATU', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'WS', TRC_NAME: 'SAMOA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'TO', TRC_NAME: 'TONGA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'CK', TRC_NAME: 'COOK ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'PW', TRC_NAME: 'PALAU', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'MH', TRC_NAME: 'MARSHALL ISLANDS', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'FM', TRC_NAME: 'MICRONESIA', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'KI', TRC_NAME: 'KIRIBATI', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'TV', TRC_NAME: 'TUVALU', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'NR', TRC_NAME: 'NAURU', TRC_TRZ_CODE: 3 },
        { TRC_SHT_DESC: 'AL', TRC_NAME: 'ALBANIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'AD', TRC_NAME: 'ANDORRA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'AT', TRC_NAME: 'AUSTRIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'BY', TRC_NAME: 'BELARUS', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'BE', TRC_NAME: 'BELGIUM', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'BA', TRC_NAME: 'BOSNIA AND HERZEGOVINA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'BG', TRC_NAME: 'BULGARIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'HR', TRC_NAME: 'CROATIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'CY', TRC_NAME: 'CYPRUS', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'CZ', TRC_NAME: 'CZECH REPUBLIC', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'DK', TRC_NAME: 'DENMARK', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'EE', TRC_NAME: 'ESTONIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'FI', TRC_NAME: 'FINLAND', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'FR', TRC_NAME: 'FRANCE', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'DE', TRC_NAME: 'GERMANY', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'GI', TRC_NAME: 'GIBRALTAR', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'GR', TRC_NAME: 'GREECE', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'HU', TRC_NAME: 'HUNGARY', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'IS', TRC_NAME: 'ICELAND', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'IE', TRC_NAME: 'IRELAND', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'IT', TRC_NAME: 'ITALY', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'XK', TRC_NAME: 'KOSOVO', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'LV', TRC_NAME: 'LATVIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'LI', TRC_NAME: 'LIECHTENSTEIN', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'LT', TRC_NAME: 'LITHUANIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'LU', TRC_NAME: 'LUXEMBOURG', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'MT', TRC_NAME: 'MALTA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'MD', TRC_NAME: 'MOLDOVA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'MC', TRC_NAME: 'MONACO', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'ME', TRC_NAME: 'MONTENEGRO', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'NL', TRC_NAME: 'NETHERLANDS', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'MK', TRC_NAME: 'NORTH MACEDONIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'NO', TRC_NAME: 'NORWAY', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'PL', TRC_NAME: 'POLAND', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'PT', TRC_NAME: 'PORTUGAL', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'RO', TRC_NAME: 'ROMANIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'RU', TRC_NAME: 'RUSSIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'SM', TRC_NAME: 'SAN MARINO', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'RS', TRC_NAME: 'SERBIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'SK', TRC_NAME: 'SLOVAKIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'SI', TRC_NAME: 'SLOVENIA', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'ES', TRC_NAME: 'SPAIN', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'SE', TRC_NAME: 'SWEDEN', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'CH', TRC_NAME: 'SWITZERLAND', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'UA', TRC_NAME: 'UKRAINE', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'GB', TRC_NAME: 'UNITED KINGDOM', TRC_TRZ_CODE: 4 },
        { TRC_SHT_DESC: 'VA', TRC_NAME: 'VATICAN CITY', TRC_TRZ_CODE: 4 },
      ];

      return countries.sort((a, b) => a.TRC_NAME.localeCompare(b.TRC_NAME));
    },

    nextStep() {
      if (this.currentStep === 1) {
        this.currentStep = 2;
      } else if (this.currentStep === 2) {
        // Validate quote details before proceeding
        if (!this.emailAddress || !this.birthDate || !this.selectedRegion || !this.selectedDuration) {
          this.$toast.error('Please complete all quote details', VALIDATION_ERROR);
          return;
        }
        if (this.emailError) {
          this.$toast.error('Please fix email validation errors', VALIDATION_ERROR);
          return;
        }

        // Skip residency selection for authenticated users
        if (this.isAuthenticated && this.authenticatedUser) {
          this.form.residency = 'resident';
          this.form.email = this.emailAddress;
          this.form.date_of_birth = this.birthDate;

          // Pre-fill all authenticated user data when skipping to personal details
          this.autofillUserData();

          this.currentStep = 5; // Skip to personal details
        } else {
          this.currentStep = 3; // Go to residency selection for non-authenticated users
        }
      } else if (this.currentStep === 3) {
        // Validate residency selection
        if (!this.form.residency) {
          this.$toast.error('Please select your residency status', VALIDATION_ERROR);
          return;
        }
        this.currentStep = 4;
      } else if (this.currentStep === 4) {
        // Authentication step - will be handled separately
        // Pre-fill form data from step 1 when moving to personal details
        this.form.email = this.emailAddress;
        this.form.date_of_birth = this.birthDate;
        this.currentStep = 5;
      } else if (this.currentStep === 5) {
        this.currentStep = 6;
      }
    },

    async handleResidentLogin() {
      try {
        // For residents, redirect to the main application login
        // Using the correct route name 'SignIn' as defined in router
        this.$router.push({ name: 'SignIn', query: { returnTo: this.$route.fullPath } });
      } catch (error) {
        // console.error('Login redirect failed:', error);
        this.$toast.error('Failed to redirect to login page', 'Error');
      }
    },

    handleNonResidentAuth() {
      // Simply proceed to personal details step
      // Authentication will be handled automatically during document upload or payment
      // Pre-fill form data from step 1 when moving to personal details
      this.form.email = this.emailAddress;
      this.form.date_of_birth = this.birthDate;
      this.currentStep = 5;
    },

    autofillUserData() {
      if (this.isAuthenticated && this.authenticatedUser) {
        // Debug: Log authenticated user data to understand available fields
        // console.log('Authenticated user data:', this.authenticatedUser);
        // Autofill from authenticated user data
        this.form.first_name = this.authenticatedUser.given_name || '';
        this.form.last_name = this.authenticatedUser.family_name || '';
        this.form.full_name = this.authenticatedUser.name || `${this.form.first_name} ${this.form.last_name}`.trim();
        this.form.email = this.authenticatedUser.email || '';
        this.form.gender = this.authenticatedUser.gender || '';
        this.form.phone_number = this.authenticatedUser.phone_number || '';
        this.form.id_number = this.authenticatedUser['custom:id_number'] || this.authenticatedUser['custom:id-number'] || '';
        this.form.id_no = this.form.id_number; // Also set the field name used in the template
        this.form.kra_pin = this.authenticatedUser['custom:kra-pin'] || this.authenticatedUser['custom:kra_pin'] || '';
        // Debug: Log what was filled
        // console.log('Form data after autofill:', {
        //   id_number: this.form.id_number,
        //   id_no: this.form.id_no,
        //   kra_pin: this.form.kra_pin,
        //   phone_number: this.form.phone_number,
        //   email: this.form.email,
        // });

        // Pre-fill emailAddress for step 2 quote generation
        this.emailAddress = this.authenticatedUser.email || '';

        // Pre-fill birth date if available from either step data or user profile
        if (this.birthDate) {
          this.form.date_of_birth = this.birthDate;
        } else if (this.authenticatedUser.birthdate) {
          this.form.date_of_birth = this.authenticatedUser.birthdate;
          this.birthDate = this.authenticatedUser.birthdate;
        }

        // Set travel start date to today if not set (user can modify)
        if (!this.form.travel_start_date) {
          const today = new Date();
          today.setDate(today.getDate() + 1); // Start from tomorrow
          const [dateOnly] = today.toISOString().split('T');
          this.form.travel_start_date = dateOnly;
        }

        // Auto-calculate end date based on selected duration if available
        if (this.selectedDuration && this.form.travel_start_date && !this.form.travel_end_date) {
          this.autoCalculateEndDate();
        }

        // Set default values for required fields if not available
        if (!this.form.gender) {
          this.form.gender = 'Male'; // Set a default that user can change
        }

        // Set default agent option for residents
        this.form.agent_option = 1; // Direct client

        // Set default politically exposed to false (user can change)
        if (this.form.politically_exposed === null || this.form.politically_exposed === undefined) {
          this.form.politically_exposed = false;
        }

        // Set default residency based on KRA PIN presence
        if (this.form.kra_pin) {
          this.form.residency = 'resident';
        }
      }
    },

    updateFullName() {
      // Update full_name whenever first_name or last_name changes
      this.form.full_name = `${this.form.first_name || ''} ${this.form.last_name || ''}`.trim();
    },
    onResidencyChange() {
      // Clear fields that are not required for non-residents
      if (this.form.residency === 'non-resident') {
        this.form.id_no = '';
        this.form.kra_pin = '';
      }
    },
    async initializeGooglePlaces() {
      this.loaded = true;
      try {
        const google = await loader.load();
        const input = document.getElementById('addressSearch');

        if (input) {
          const autocompleteOptions = this.isAuthenticated
            ? { componentRestrictions: { country: 'ke' }, strictBounds: true }
            : { types: ['address'] }; // Worldwide for non-residents

          const autocomplete = new google.maps.places.Autocomplete(input, autocompleteOptions);

          google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.fillAddressFromGoogle(place);
          });
        }
      } catch (error) {
        // console.error('Error loading Google Places API:', error);
        this.$toast.error('Failed to load address autocomplete', 'Error');
      }
    },
    fillAddressFromGoogle(place) {
      // Extract address components from Google Places result
      const components = place.address_components || [];
      const addressData = {
        street: '',
        area: '',
        city: '',
        postal_code: '',
      };

      components.forEach((component) => {
        const { types } = component;
        if (types.includes('street_number') || types.includes('route')) {
          addressData.street += `${component.long_name} `;
        } else if (types.includes('sublocality') || types.includes('neighborhood')) {
          addressData.area = component.long_name;
        } else if (types.includes('locality') || types.includes('administrative_area_level_2')) {
          addressData.city = component.long_name;
        } else if (types.includes('postal_code')) {
          addressData.postal_code = component.long_name;
        }
      });

      // Update form with Google Places data
      this.form.address.street = addressData.street.trim();
      this.form.address.area = addressData.area || this.form.address.area;
      this.form.address.city = addressData.city || this.form.address.city;
      this.form.address.postal_code = addressData.postal_code || this.form.address.postal_code;
      this.form.address.search_address = place.formatted_address || '';
      // Store coordinates if available
      if (place.geometry && place.geometry.location) {
        this.form.address.coordinates = {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        };
      }
    },
    searchAddress() {
      // This method can be used for manual address search if needed
    },
    // Enhanced flow methods
    calculateAge(birthDate) {
      if (!birthDate) return 0;
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age -= 1;
      }

      return age;
    },

    formatPlanType(planType) {
      switch (planType?.toLowerCase()) {
        case 'individual': return 'Individual Plan';
        case 'family': return 'Family Plan';
        case 'student': return 'Student Plan';
        default: return planType || 'Travel Plan';
      }
    },

    getDateOfBirthPlaceholder() {
      if (this.selectedPlan === 'individual' && this.buyingFor === 'someone_else') {
        return 'Select date of birth (1+ years)';
      }
      return 'Select your date of birth (18+ years)';
    },

    // formatQuoteDate method removed - no longer used without existing quotes UI

    validateEmail() {
      if (!this.emailAddress) {
        this.emailError = 'Email address is required';
        return false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.emailAddress)) {
        this.emailError = 'Please enter a valid email address';
        return false;
      }

      this.emailError = '';
      return true;
    },

    validateEmailOnKeyup() {
      if (this.emailAddress) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(this.emailAddress)) {
          this.emailError = '';
          // Note: Saved quotes are now shown only for authenticated users in the SavedQuotes page
        }
      }
    },

    // Email-based quote fetching removed - saved quotes are now shown only for authenticated users

    mapBackendPlanToFrontend(travelPlan) {
      // Map backend travel_plan values to our frontend plan types
      if (travelPlan && travelPlan.toLowerCase().includes('student')) {
        return 'student';
      }
      if (travelPlan && travelPlan.toLowerCase().includes('family')) {
        return 'family';
      }
      return 'individual';
    },

    calculateDurationFromDates(startDate, endDate) {
      if (!startDate || !endDate) return 'Unknown';

      try {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays <= 4) return '1-4 days';
        if (diffDays <= 7) return '5-7 days';
        if (diffDays <= 10) return '8-10 days';
        if (diffDays <= 15) return '11-15 days';
        if (diffDays <= 21) return '16-21 days';
        if (diffDays <= 30) return '22-30 days';
        if (diffDays <= 60) return '31-60 days';
        if (diffDays <= 90) return '61-90 days';
        if (diffDays <= 180) return '91-180 days';
        return '1 year trip';
      } catch (error) {
        return 'Unknown';
      }
    },

    async proceedToStep2() {
      if (!this.validateEmail()) {
        return;
      }

      if (this.price && this.birthDate && this.emailAddress) {
        try {
          this.loadingBuyNow = true;

          // If we don't have a current quote, fetch pricing first
          if (!this.currentQuote) {
            await this.fetchPricing();
          }

          if (this.currentQuote) {
            // Pre-populate form data with step 1 selections - only fields already provided
            this.form.email = this.emailAddress;
            this.form.date_of_birth = this.birthDate;
            // Auto-set travel plan based on step 1 selections
            this.setTravelPlanFromStep1();

            // Update the quote with email if needed
            if (this.currentQuoteId && this.emailAddress) {
              try {
                await axios.patch(`${TRAVEL_QUOTES_API}/${this.currentQuoteId}`, null, {
                  params: { email_address: this.emailAddress },
                });
              } catch (error) {
                // console.warn('Could not update quote with email:', error);
              }
            }

            this.currentStep = 2;
            this.$nextTick(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            });
          } else {
            this.$toast.error('Unable to calculate pricing. Please try again.', 'Error');
          }
        } catch (error) {
          // console.error('Error proceeding to step 2:', error);
          this.$toast.error('Error proceeding to step 2. Please try again.', 'Error');

          // Don't crash the page - user can retry
          // Reset loading state and stay on current step
        } finally {
          this.loadingBuyNow = false;
        }
      }
    },

    // createNewQuote method removed - no longer needed without existing quotes

    // loadExistingQuote and deleteQuote methods removed - saved quotes now handled in SavedQuotes page

    async fetchPricing() {
      // Check if we have basic information first
      if (!this.selectedRegion || !this.selectedPlan || !this.birthDate || !this.emailAddress) {
        this.$toast.error('Please fill in all required fields before getting a price', 'Missing Information');
        return;
      }

      // Check if we have the required additional fields for Mapfre API
      if (!this.form.full_name || !this.form.passport_no) {
        this.$toast.error('Please provide your full name and passport number to get pricing', 'Additional Information Required');
        return;
      }

      try {
        this.loadingPrice = true;

        // Calculate start and end dates
        const startDate = this.form.travel_start_date || this.getEstimatedStartDate();
        const endDate = this.form.travel_end_date || this.getEstimatedEndDate();

        // Get product code and zone based on region and plan
        const prodCode = this.getMapfreProductCode(this.selectedRegion, this.selectedPlan);
        const zone = this.getZoneCode(this.selectedRegion);

        // Parse full name into first and last name
        const nameParts = this.form.full_name.trim().split(' ');
        const firstName = nameParts[0] || '';
        const surname = nameParts.slice(1).join(' ') || firstName;

        // Create Mapfre pricing request payload (no premium field - let Mapfre calculate based on age)
        const pricingData = {
          prodCode,
          policyNumber: 'AUTO',
          startDate,
          endDate,
          agnShtDesc: this.selectedAgent || 'DIRECT',
          zone,
          destinationCountry: this.selectedCountry || 'KE',
          insuredData: [{
            insuredFirstName: firstName,
            insuredSurname: surname,
            // insuredFirstName: 'TEST',
            // insuredSurname: 'TEST',
            insuredDateOfBirth: this.birthDate,
            insuredPassport: this.form.passport_no,
          }],
          policyholderFirstName: firstName,
          policyholderSurname: surname,
          policyholderPassport: this.form.passport_no,
          policyholderDateOfBirth: this.birthDate,
          coverageLimits: this.getDefaultCoverageLimits(prodCode),
        };

        // console.log('Sending Mapfre pricing request:', pricingData);

        // Call Mapfre pricing API
        const response = await axios.post('https://prod.api.pacisinsurance.com/customer/gis/mapfre/policy/getPrice', pricingData, {
          headers: {
            // Authorization: 'Bearer{{authToken}}',
            'Content-Type': 'application/json',
          },
        });

        // console.log('Received Mapfre pricing response:', response.data);

        if (response.data.success && response.data.data) {
          const premium = response.data.data.grossPrice;
          this.currentQuote = {
            id: `mapfre_${Date.now()}`,
            premium,
            prodCode,
            zone,
          };

          // Create quote in database with pricing data
          await this.createQuoteWithPricing(response.data.data);

          this.$toast.success('Pricing calculated successfully', 'Success');
        } else {
          throw new Error(response.data.message || 'Failed to get pricing from Mapfre');
        }
      } catch (error) {
        // console.error('Failed to fetch Mapfre pricing:', error);
        // console.error('Error details:', error.response?.data);
        this.currentQuote = null;
        this.$toast.error('Failed to fetch Mapfre pricing');
        this.loadingPrice = false;
      }
    },

    async createQuoteWithPricing(pricingData) {
      try {
        // Update form with current selections for proper store context
        this.form.plan_type = this.selectedPlan;
        this.form.region = this.selectedRegion;
        this.form.duration = this.selectedDuration;
        this.form.date_of_birth = this.birthDate;
        this.form.email = this.emailAddress;
        this.form.destination_country = this.selectedCountry;
        this.form.premium = pricingData.grossPrice;

        // Create quote with form data and pricing
        const quoteData = {
          plan_type: this.selectedPlan,
          region: this.selectedRegion,
          duration: this.selectedDuration,
          birth_date: this.birthDate,
          email_address: this.emailAddress,
          // Personal details
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          passport_no: this.form.passport_no,
          id_no: this.form.id_no,
          // Travel details
          destination_country: this.selectedCountry,
          travel_start_date: this.form.travel_start_date,
          travel_end_date: this.form.travel_end_date,
        };

        // Create the quote
        const quoteResponse = await axios.post('/customer/digital-quotation/pacis-travel/quotes', quoteData);

        // Update quote with pricing data
        if (quoteResponse.data && quoteResponse.data.id) {
          await axios.patch(`/customer/digital-quotation/pacis-travel/quotes/${quoteResponse.data.id}/pricing`, pricingData);

          // Update currentQuote with actual database ID
          this.currentQuote.id = quoteResponse.data.id;

          // Update store with complete form data including quote info
          this.form.quote_id = quoteResponse.data.id;
          this.updateTravelContext();

          // console.log('Quote created successfully with ID:', quoteResponse.data.id);
        }
      } catch (error) {
        // console.error('Failed to create quote:', error);
        // Still update store with form data for temporary quote flow
        this.updateTravelContext();
      }
    },

    getMapfreProductCode(region, planType) {
      const productMapping = {
        // Africa (Zone 1)
        [REGION_AFRICA]: {
          individual: 'AFR_IND',
          family: 'AFR_FAM',
        },
        // Asia (Zone 12)
        [REGION_ASIA]: {
          individual: 'ASI_IND',
          family: 'ASI_FAM',
        },
        // Europe (Zone 2)
        Europe: {
          individual: 'EUR_BAS', // Europe Plus Individual
          family: 'EUR_FAM_BAS', // Europe Family Basic
        },
        // Worldwide (Zone 3)
        'Worldwide Classic': {
          student: 'STU_BAS', // Student Basic
        },
        'Worldwide Basic': {
          individual: 'WW_IND_BAS', // Worldwide Basic Individual
          family: 'WW_FAM_BAS', // Worldwide Basic Family
        },
        'Worldwide Premium': {
          individual: 'WW_IND_PRE', // Worldwide Premium Individual
          family: 'WW_FAM_PRE', // Worldwide Premium Family
          student: 'STU_PRE', // Student Premium
        },
        'Worldwide Extra': {
          individual: 'WW_IND_EXT', // Worldwide Extra Individual
          family: 'WW_FAM_EXT', // Worldwide Extra Family
        },
      };

      return productMapping[region]?.[planType] || 'AFR_IND';
    },

    getZoneCode(region) {
      const zoneMapping = {
        [REGION_AFRICA]: '1',
        [REGION_ASIA]: '12',
        Europe: '2',
        'Worldwide Classic': '3',
        'Worldwide Basic': '3',
        'Worldwide Premium': '3',
        'Worldwide Extra': '3',
      };
      return zoneMapping[region] || '1';
    },

    getDefaultCoverageLimits(prodCode) {
      // Default coverage limits based on product type
      const defaultLimits = {
        deliveryOfMedicines: '1',
        emergencyDentalCare: '1',
        assistanceServices24Hours: '1',
        baggageDelayCompensation: '1',
      };

      // Add additional coverages for specific products
      if (prodCode.startsWith('EUR_')) {
        return {
          ...defaultLimits,
          winterSport: '1',
          hospitalization: '1',
          medicalTransportation: '1',
          personalAssistance: '1',
          accidentalDamagePhoneGadget: '1',
          curtailment: '1',
          baggage: '1',
          travelDelay: '1',
        };
      }

      if (prodCode === 'CORP') {
        return {
          ...defaultLimits,
          curtailment: '1',
          medicalTransportation: '1',
          medicalExpenses: '1',
          personalAssistance: '1',
          personalLiability: '1',
          advanceOfBailBondLiability: '1',
          baggage: '1',
          cancellation: '1',
          travelDelay: '1',
        };
      }

      return defaultLimits;
    },

    mapFrontendPlanToBackend(planType) {
      const planMapping = {
        individual: 'individual',
        family: 'family',
        student: 'students_classic',
      };
      return planMapping[planType] || 'individual';
    },

    getEstimatedStartDate() {
      // Default to 30 days from now
      const future = new Date();
      future.setDate(future.getDate() + 30);
      return future.toISOString().split('T')[0];
    },

    getEstimatedEndDate() {
      // Calculate end date based on duration
      const start = new Date(this.getEstimatedStartDate());
      const durationDays = this.getDurationInDays(this.selectedDuration);
      start.setDate(start.getDate() + durationDays);
      return start.toISOString().split('T')[0];
    },

    getDurationInDays(duration) {
      const durationMap = {
        '1-4 days': 4,
        '5-7 days': 7,
        '8-10 days': 10,
        '11-15 days': 15,
        '16-21 days': 21,
        '22-30 days': 30,
        '31-60 days': 60,
        '61-90 days': 90,
        '91-180 days': 180,
        '1 year trip': 365,
        '6 months': 180,
        '9 months': 270,
        '1 year': 365,
      };
      return durationMap[duration] || 30;
    },

    // Removed unused pricing calculation methods since we're using backend pricing

    getRegionBenefits(region) {
      const GLOBAL_COVERAGE = 'Global coverage except country of residence';

      const benefitsMap = {
        [REGION_AFRICA]: {
          medical: 15000,
          evacuation: 15000,
          cancellation: 2000,
          effects: 1500,
          coverage: 'All African countries & islands (except country of residence)',
          additional: [],
          features: ['Essential medical coverage', 'Basic evacuation services'],
        },
        [REGION_ASIA]: {
          medical: 15000,
          evacuation: 15000,
          cancellation: 2000,
          effects: 1500,
          coverage: 'Asian continent (except country of residence)',
          additional: [],
          features: ['Essential medical coverage', 'Basic evacuation services'],
        },
        Europe: {
          medical: 40000,
          evacuation: 40000,
          cancellation: 5000,
          effects: 3000,
          coverage: 'All European countries including Schengen Area',
          additional: [
            { name: 'Delayed Departure', amount: 300 },
            { name: 'Accidental Death (Public Transport)', amount: 10000 },
          ],
          features: ['Enhanced medical coverage for European travel', 'Schengen visa compliant'],
        },
        'Worldwide Basic': {
          medical: 40000,
          evacuation: 40000,
          cancellation: 8000,
          effects: 5000,
          coverage: GLOBAL_COVERAGE,
          additional: [
            { name: 'Journey Cancellation', amount: 2000 },
            { name: 'Personal Liability', amount: 100000 },
            { name: 'Legal Defense', amount: 3500 },
          ],
          features: ['Comprehensive travel disruption coverage', 'Global emergency assistance'],
        },
        'Worldwide Premium': {
          medical: 75000,
          evacuation: 75000,
          cancellation: 12000,
          effects: 8000,
          coverage: GLOBAL_COVERAGE,
          additional: [
            { name: 'Journey Cancellation', amount: 3000 },
            { name: 'Hospital Daily Cash', amount: 50 },
          ],
          features: ['Enhanced daily hospital cash benefit', 'Higher coverage limits'],
        },
        'Worldwide Extra': {
          medical: 150000,
          evacuation: 150000,
          cancellation: 20000,
          effects: 15000,
          coverage: GLOBAL_COVERAGE,
          additional: [
            { name: 'Accidental Death (Public Transport)', amount: 50000 },
          ],
          features: ['Highest tier medical coverage', 'Maximum protection for high-value travelers'],
        },
      };

      return benefitsMap[region] || {
        medical: 0,
        evacuation: 0,
        cancellation: 0,
        effects: 0,
        coverage: 'No coverage information available',
        additional: [],
        features: [],
      };
    },

    getRegionDisplayName(region) {
      const displayNames = {
        [REGION_AFRICA]: REGION_AFRICA,
        [REGION_ASIA]: REGION_ASIA,
        Europe: 'Europe',
        'Worldwide Basic': 'Worldwide Basic',
        'Worlwide Premium': 'Worlwide Premium',
        'Worldwide Extra': 'Worldwide Extra',
        'Worldwide Classic': 'Worldwide Classic (Students)',
        'Worldwide Premium': 'Worldwide Premium (Students)',
      };

      return displayNames[region] || region;
    },

    proceed() {
      // Only validate beneficiaries for family plans
      if (this.selectedPlan === 'family' && !this.beneficiariesValid) {
        this.$toast.error('Total beneficiary percentage cannot exceed 100%', 'Validation Error');
        return;
      }

      // Use existing quote from fetchPricing instead of creating a new one
      if (this.currentQuote) {
        // Update the current quote with form data for the quote summary
        const selectedPlan = this.travel_plans.find((plan) => plan.value === this.form.travel_plan);
        const enhancedQuote = {
          ...this.currentQuote,
          residency: this.form.residency,
          full_name: this.form.full_name,
          date_of_birth: this.form.date_of_birth,
          email: this.form.email,
          passport_no: this.form.passport_no,
          id_no: this.form.id_no,
          kra_pin: this.form.kra_pin,
          address: this.form.address,
          mobile_main: this.form.mobile_main,
          mobile_alternative: this.form.mobile_alternative,
          next_of_kin: this.form.next_of_kin,
          beneficiaries: this.selectedPlan === 'family' ? this.form.beneficiaries : [],
          politically_exposed: this.form.politically_exposed,
          travel_start_date: this.form.travel_start_date,
          travel_end_date: this.form.travel_end_date,
          destination: this.selectedRegion,
          selectedCountry: this.selectedCountry,
          travel_plan: this.form.travel_plan,
          travel_plan_type: selectedPlan ? selectedPlan.type : '',
          coverage_amount: selectedPlan ? selectedPlan.limit : 0,
          declaration: this.form.declaration,
          data_privacy: this.form.data_privacy,
          application_date: new Date().toISOString().split('T')[0],
          // Agent information
          agent_option: this.agentOption,
          selected_agent: this.agentOption === 2 ? this.selectedAgent : null,
        };

        this.$store.commit(SET_TRAVEL_QUOTE_RESPONSE, enhancedQuote);

        // Store the form data for use in the next step
        this.$store.commit('rfq/setTravelFormData', this.form);
        // console.log('StartTravel - Storing form data in Vuex:', this.form);

        // Check buying scenario and residency to navigate accordingly
        if (this.selectedPlan === 'individual' && this.buyingFor === 'someone_else' && this.calculateAge(this.birthDate) >= 18) {
          // For buying for someone else (18+), go to separate buyer/policyholder flow
          this.$router.push({
            name: 'BuyForSomeoneElseCover',
            query: { q: this.currentQuote.id },
          });
        } else if (this.form.residency === 'non-resident') {
          // For non-residents, go directly to non-resident buy cover page
          this.$router.push({
            name: 'NonResidentTravelBuyCover',
            query: { q: this.currentQuote.id },
          });
        } else {
          // For residents, navigate to quote summary for authentication
          this.$router.push({
            name: 'TravelQuoteSummary',
            query: { q: this.currentQuote.id },
          });
        }
      } else {
        this.$toast.error('Please get a quote first by completing the basic travel information.', 'Quote Required');
      }
    },

    async proceedToPayment() {
      try {
        // First get the quote from Mapfre pricing API
        await this.fetchPricing();

        // Check if we got a valid quote
        if (!this.currentQuote) {
          this.$toast.error('Unable to get pricing quote. Please try again.', 'Error');
          return;
        }

        if (this.isAuthenticated && this.authenticatedUser) {
          // For authenticated users, show quote summary first for review
          this.proceedToQuoteSummary();
        } else {
          // For non-authenticated users, proceed to quote summary
          // This handles both residents and non-residents the same way
          this.proceed();
        }
      } catch (error) {
        this.$toast.error('Error getting quote. Please try again.', 'Error');
      }
    },

    proceedToQuoteSummary() {
      // Navigate to standalone quote summary page for review before payment
      if (this.currentQuote) {
        // Store the quote data in vuex for the summary page
        this.$store.commit(SET_TRAVEL_QUOTE_RESPONSE, this.currentQuote);

        // Navigate to quote summary page
        this.$router.push({
          name: 'TravelQuoteSummary',
          query: { q: this.currentQuote.id },
        });
      } else {
        this.$toast.error('Quote data not available', 'Error');
      }
    },

    proceedDirectToPersonalDetails() {
      // Direct navigation to BuyCover for travel insurance
      if (this.currentQuote) {
        // Store the quote data in vuex
        this.$store.commit(SET_TRAVEL_QUOTE_RESPONSE, this.currentQuote);

        // Store the form data with pre-filled authenticated user data
        this.$store.commit('rfq/setTravelFormData', this.form);
        // console.log('StartTravel - Storing form data in Vuex for direct navigation:', this.form);
        // console.log('StartTravel - Specifically storing id_number:', this.form.id_number);
        // console.log('StartTravel - Specifically storing kra_pin:', this.form.kra_pin);

        // Set up payment context for direct payment flow
        // Convert USD premium to KSH for payment
        const kshAmount = Math.round(this.currentQuote.premium * this.exchangeRate);
        const payment = {
          payableAmount: kshAmount,
          productId: this.currentQuote.id,
          email: this.currentQuote.email_address || this.form.email,
          phoneNumber: this.form.phone_number,
          transactionReference: travelPaymentReference(this.form.id_no || this.form.id_number || this.form.passport_no),
          transactionDescription: `TV_rfq-${this.currentQuote.id}`,
          quoteData: this.currentQuote,
          formData: this.form,
        };
        // console.log('Setting payment context:', payment);
        this.$store.commit('payments/setPaymentContext', payment);

        // Navigate to BuyCover with direct payment flow for travel insurance
        this.$router.push({
          name: 'BuyCover',
          query: { q: this.currentQuote.id, b: 'travel', payment: 'direct' },
        });
      } else {
        this.$toast.error('Quote data not available. Please get a quote first.', 'Error');
      }
    },

    // Agent methods
    applyReferralAgent() {
      if (!this.referralAgent) return;
      this.agentOption = 2;
      this.selectedAgent = this.referralAgent.agencyName;
      this.agentListItems = [this.referralAgent.agencyName];
    },
    getAgentList() {
      this.agentLoading = true;
      axios.get('https://prod.api.pacisinsurance.com/customer/gis/coresetups/agencies/all').then((response) => {
        this.agentLoading = false;
        this.agentList = response.data.object;
        // Populate agentListItems immediately after loading
        this.agentListItems = this.agentList.map((agent) => agent.agencyName);
      }).catch(() => {
        this.agentLoading = false;
        this.$toast.error('Failed to load agent list. Please try again.', 'Error');
      });
    },

    agentListFilter(v) {
      const agents = [];
      this.agentList.forEach((agent) => {
        agents.push(agent.agencyName);
      });
      setTimeout(() => {
        this.agentListItems = agents.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
      }, 500);
    },

    // Date calculation methods
    calculateMainTripDuration() {
      if (!this.form.travel_start_date || !this.form.travel_end_date) return 0;
      const startDate = new Date(this.form.travel_start_date);
      const endDate = new Date(this.form.travel_end_date);
      const diffTime = Math.abs(endDate - startDate);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },

    autoCalculateEndDate() {
      // Auto-calculate end date based on start date and selected duration
      if (this.form.travel_start_date && this.selectedDuration) {
        const startDate = new Date(this.form.travel_start_date);
        const durationDays = this.getDurationInDays(this.selectedDuration);

        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + durationDays);

        [this.form.travel_end_date] = endDate.toISOString().split('T');

        // console.log(`Auto-calculated end date: ${this.form.travel_end_date} (${durationDays} days from ${this.form.travel_start_date})`);
      }
    },

    calculateLongestDuration() {
      return this.calculateMainTripDuration();
    },

    setTravelPlanFromStep1() {
      // Map Step 1 selections to the travel plan value used in Step 2
      if (!this.selectedRegion || !this.selectedPlan) {
        return;
      }

      // Map region and plan type to travel plan value
      let travelPlanValue = '';

      if (this.selectedPlan === 'student') {
        if (this.selectedRegion === 'Worldwide Classic') {
          travelPlanValue = 'students_classic';
        } else if (this.selectedRegion === 'Worldwide Premium') {
          travelPlanValue = 'students_premium';
        }
      } else {
        // For individual and family plans
        switch (this.selectedRegion) {
          case REGION_AFRICA:
          case REGION_ASIA:
            travelPlanValue = 'africa'; // or 'asia' - could be either
            break;
          case 'Europe':
            travelPlanValue = 'europe_schengen';
            break;
          case 'Worldwide Basic':
            travelPlanValue = 'worldwide_basic';
            break;
          case 'Worlwide Premium':
            travelPlanValue = 'worldwide_premium';
            break;
          case 'Worldwide Extra':
            travelPlanValue = 'worldwide_extra';
            break;
          default:
            travelPlanValue = 'worldwide_basic'; // fallback
        }
      }

      // Set the travel plan in the form
      this.form.travel_plan = travelPlanValue;
    },
  },
};
</script>

<style scoped>
.tw-text-red-500 {
  color: #ef4444;
}

/* Plan option styling */
.plan-option {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.plan-option:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.plan-option.selected {
  border: 2px solid #1976d2;
  transform: translateY(-2px);
}

/* Stepper styling */
.stepper-item {
  transition: color 0.2s ease;
}

.stepper-item:hover {
  color: #1976d2;
}

/* Quote card styling */
.quote-card {
  transition: all 0.3s ease;
  border-radius: 12px !important;
}

.quote-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.12) !important;
}

/* Benefit item styling */
.benefit-item {
  padding: 0.5rem 0;
}
</style>
